webpackJsonp([1],Array(27).concat([
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(306)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(370),
  /* scopeId */
  "data-v-40664a94",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(289)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(353),
  /* scopeId */
  "data-v-00124cce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(310)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(374),
  /* scopeId */
  "data-v-4cc75f6e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(307)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(371),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(303)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(367),
  /* scopeId */
  "data-v-35d053fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(304)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(368),
  /* scopeId */
  "data-v-3b00c717",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(319)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(383),
  /* scopeId */
  "data-v-929b5f0a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(296)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(360),
  /* scopeId */
  "data-v-1515d56e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(293)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(357),
  /* scopeId */
  "data-v-08c58dee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Medico__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Medico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Medico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MedicoEdit__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MedicoEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_MedicoEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MedicoNew__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MedicoNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_MedicoNew__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Empresa__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Empresa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Empresa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_EmpresaEdit__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_EmpresaEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_EmpresaEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_EmpresaNew__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_EmpresaNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_EmpresaNew__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ResultadoList__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ResultadoList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_ResultadoList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ResultadoPacienteCardList__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ResultadoPacienteCardList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ResultadoPacienteCardList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ResultadoPaciente__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ResultadoPaciente___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_ResultadoPaciente__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CartaoAcesso__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CartaoAcesso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_CartaoAcesso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ResultadoShareCard__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ResultadoShareCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_ResultadoShareCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_NotFound__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_NotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Login__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_RedefinirSenha__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_RedefinirSenha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_RedefinirSenha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Usuario__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Usuario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Usuario__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_UsuarioEdit__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_UsuarioEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_UsuarioEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_UsuarioNew__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_UsuarioNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_UsuarioNew__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Unidade__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Unidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Unidade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_UnidadeEdit__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_UnidadeEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_UnidadeEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_UnidadeNew__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_UnidadeNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_UnidadeNew__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Menu__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_MenuEdit__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_MenuEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_MenuEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_MenuNew__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_MenuNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_MenuNew__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_axios__);





























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var isLogged = function isLogged(to, from, next) {
  console.log('islogged ' + (window.localStorage.getItem('token') != null));
  if (to.query.access_token) {
    console.log('to.query.access_token', to.query.access_token);
    window.localStorage.setItem('token', to.query.access_token);
    __WEBPACK_IMPORTED_MODULE_26_axios___default.a.defaults.headers.common['X-Auth-Token'] = window.localStorage.getItem('token');
    console.log('localstprage', window.localStorage.getItem('token'));
  }
  if (window.localStorage.getItem('token')) {
    console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa');
    __WEBPACK_IMPORTED_MODULE_26_axios___default.a.get('/validarToken').then(function (response) {
      next();
    }).catch(function (e) {
      window.localStorage.removeItem('token');
      __WEBPACK_IMPORTED_MODULE_26_axios___default.a.defaults.headers.common['X-Auth-Token'] = null;
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
    });
  } else {
    var login = '/login';
    if (to.params.empresa) {
      login += '/' + to.params.empresa;
    }
    next({
      path: login,
      query: {
        redirect: to.fullPath
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a,
    beforeEnter: isLogged
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Login___default.a
  }, {
    path: '/login/:e',
    name: 'LoginEmpresa',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Login___default.a
  }, {
    path: '/redefinir-senha',
    name: 'RedefinirSenha',
    component: __WEBPACK_IMPORTED_MODULE_16__components_RedefinirSenha___default.a
  }, {
    path: '/redefinir-senha/:code',
    name: 'RedefinirSenha',
    component: __WEBPACK_IMPORTED_MODULE_16__components_RedefinirSenha___default.a
  }, {
    path: '/notFound',
    name: 'NotFound',
    component: __WEBPACK_IMPORTED_MODULE_14__components_NotFound___default.a
  }, {
    path: '/admin/resultado',
    name: 'ResultadoList',
    component: __WEBPACK_IMPORTED_MODULE_9__components_ResultadoList___default.a,
    beforeEnter: isLogged
  }, {
    path: '/resultado/:resultado',
    name: 'ResultadoPaciente',
    component: __WEBPACK_IMPORTED_MODULE_11__components_ResultadoPaciente___default.a
  }, {
    path: '/cartao-acesso/:resultado',
    name: 'CartaoAcesso',
    component: __WEBPACK_IMPORTED_MODULE_12__components_CartaoAcesso___default.a,
    beforeEnter: isLogged
  }, {
    path: '/resultado-compartilhado/:share/:empresa',
    name: 'ResultadoShareCard',
    component: __WEBPACK_IMPORTED_MODULE_13__components_ResultadoShareCard___default.a,
    beforeEnter: isLogged
  }, {
    path: '/resultados',
    name: 'ResultadoPacienteCardList',
    component: __WEBPACK_IMPORTED_MODULE_10__components_ResultadoPacienteCardList___default.a,
    beforeEnter: isLogged
  }, {
    path: '/admin/empresa',
    name: 'Empresa',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Empresa___default.a,
    beforeEnter: isLogged
  }, {
    path: '/admin/empresa/new',
    name: 'EmpresaNew',
    component: __WEBPACK_IMPORTED_MODULE_8__components_EmpresaNew___default.a,
    beforeEnter: isLogged
  }, {
    path: '/admin/empresa/edit/:id',
    name: 'EmpresaEdit',
    component: __WEBPACK_IMPORTED_MODULE_7__components_EmpresaEdit___default.a,
    beforeEnter: isLogged
  }, {
    path: '/admin/unidade',
    name: 'Unidade',
    component: __WEBPACK_IMPORTED_MODULE_20__components_Unidade___default.a,
    beforeEnter: isLogged
  }, {
    path: '/admin/unidade/new',
    name: 'UnidadeNew',
    component: __WEBPACK_IMPORTED_MODULE_22__components_UnidadeNew___default.a,
    beforeEnter: isLogged
  }, {
    path: '/admin/unidade/edit/:id',
    name: 'UnidadeEdit',
    component: __WEBPACK_IMPORTED_MODULE_21__components_UnidadeEdit___default.a,
    beforeEnter: isLogged
  }, {
    path: '/admin/medico',
    name: 'Medico',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Medico___default.a,
    beforeEnter: isLogged
  }, {
    path: '/admin/medico/new',
    name: 'MedicoNew',
    component: __WEBPACK_IMPORTED_MODULE_5__components_MedicoNew___default.a,
    beforeEnter: isLogged
  }, {
    path: '/admin/medico/edit/:id',
    name: 'MedicoEdit',
    component: __WEBPACK_IMPORTED_MODULE_4__components_MedicoEdit___default.a,
    beforeEnter: isLogged
  }, {
    path: '/admin/usuario',
    name: 'Usuario',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Usuario___default.a,
    beforeEnter: isLogged
  }, {
    path: '/admin/usuario/new',
    name: 'UsuarioNew',
    component: __WEBPACK_IMPORTED_MODULE_19__components_UsuarioNew___default.a,
    beforeEnter: isLogged
  }, {
    path: '/admin/usuario/edit/:id',
    name: 'UsuarioEdit',
    component: __WEBPACK_IMPORTED_MODULE_18__components_UsuarioEdit___default.a,
    beforeEnter: isLogged
  }, {
    path: '/admin/menu',
    name: 'Menu',
    component: __WEBPACK_IMPORTED_MODULE_23__components_Menu___default.a,
    beforeEnter: isLogged
  }, {
    path: '/admin/menu/new',
    name: 'MenuNew',
    component: __WEBPACK_IMPORTED_MODULE_25__components_MenuNew___default.a,
    beforeEnter: isLogged
  }, {
    path: '/admin/menu/edit/:id',
    name: 'MenuEdit',
    component: __WEBPACK_IMPORTED_MODULE_24__components_MenuEdit___default.a,
    beforeEnter: isLogged
  }]
}));

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */,
/* 197 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(322)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(386),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_color__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_analytics__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_the_mask__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_the_mask__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_the_mask___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  theme: {
    primary: '#5e35b1',
    secondary: '#424242',
    accent: '#9c27b0',
    error: '#B71C1C',
    info: '#0D47A1',
    success: '#2E7D32',
    warning: '#ffb300',
    itemmenu: '#b388ff',
    cert: '#a6a6a6'

  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.devtools = true;

var isProduction = "production" === 'production';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_analytics___default.a, {
  id: 'UA-103937643-2',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  debug: {
    enabled: !isProduction,
    sendHitTask: isProduction
  }
});

__WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.baseURL = isProduction ? 'https://rapi.mezzow.com/api' : 'http://localhost:8090/api';
__WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.headers.post['Content-Type'] = 'application/json';

var store = new __WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */].Store({
  state: {
    count: 0,
    medicoQuery: '',
    empresaQuery: '',
    unidadeQuery: '',
    usuarioQuery: '',
    menuQuery: '',
    cabecalho: { nomeEmpresa: 'Mezzow QR' },
    userLogin: null,
    menu: []
  },
  mutations: {
    increment: function increment(state) {
      state.count++;
    },
    changeMedicoQuery: function changeMedicoQuery(state, params) {
      state.medicoQuery = params.query;
    },
    changeEmpresaQuery: function changeEmpresaQuery(state, params) {
      state.empresaQuery = params.query;
    },
    changeUnidadeQuery: function changeUnidadeQuery(state, params) {
      state.unidadeQuery = params.query;
    },
    changeUsuarioQuery: function changeUsuarioQuery(state, params) {
      state.usuarioQuery = params.query;
    },
    changeMenuQuery: function changeMenuQuery(state, params) {
      state.menuQuery = params.query;
    },
    changeCabecalho: function changeCabecalho(state, params) {
      state.cabecalho = params.cabecalho;
      if (state.cabecalho.cor) {
        var metaThemeColor = document.querySelector('meta[name=theme-color]');
        metaThemeColor.setAttribute('content', state.cabecalho.cor);
        this._vm.$vuetify.theme.primary = state.cabecalho.cor;
        this._vm.$vuetify.theme.accent = __WEBPACK_IMPORTED_MODULE_7_color___default()(state.cabecalho.cor).darken(0.3).rgbNumber();
        this._vm.$vuetify.theme.itemmenu = __WEBPACK_IMPORTED_MODULE_7_color___default()(state.cabecalho.cor).lighten(0.3).rgbNumber();
      }
    },
    changeMenu: function changeMenu(state, params) {
      var p = 'resultado=' + params.r + '&empresa=' + params.e;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('/menu?' + p).then(function (response) {
        state.menu = response.data.list;
        if (response.data.cabecalho) {
          self.commit('changeCabecalho', { cabecalho: response.data.cabecalho });
        }
      }).catch(function (e) {
        state.menu = [];
      });
    },
    changeUser: function changeUser(state, params) {
      state.userLogin = params.user;
      if (params.user) {
        window.localStorage.setItem('token', params.user.access_token);
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.headers.common['X-Auth-Token'] = params.user.access_token;
      } else {
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('user');
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.headers.common['X-Auth-Token'] = null;
      }
    }
  }
});

if (window.localStorage.getItem('token')) {
  __WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.headers.common['X-Auth-Token'] = window.localStorage.getItem('token');
  store.commit('changeUser', {
    user: {
      access_token: window.localStorage.getItem('token')
    }
  });
}

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: store,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      clipped: true,
      drawer: false,
      miniVariant: true,
      title: 'Mezzow QR'
    };
  },

  watch: {
    search: function search() {}
  },
  methods: {
    logout: function logout() {
      window.localStorage.removeItem('token');
      window.localStorage.removeItem('user');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['Authorization'] = null;
      this.$store.commit('changeMenu', { menu: [] });
      this.$store.commit('changeUser', { user: null });
      this.$router.push({ path: '/login' });
    },
    buscaMenu: function buscaMenu() {
      this.$store.commit('changeMenu', this.$route.params);
    }
  },
  computed: {
    menuApp: function menuApp() {
      return this.$store.state.menu ? this.$store.state.menu : [];
    },
    tituloApp: function tituloApp() {
      return this.$store.state.cabecalho.nomeEmpresa ? this.$store.state.cabecalho.nomeEmpresa : this.title;
    },
    linkEmpresa: function linkEmpresa() {
      return this.$store.state.cabecalho.site;
    },
    showMenu: function showMenu() {
      console.log('rota ', this.$route.name);
      return this.$route.name !== 'Login' && this.$route.name !== 'LoginEmpresa' && this.$route.name !== 'RedefinirSenha' && this.$route.name !== 'CartaoAcesso';
    },
    logado: function logado() {
      console.log('this.$store.state.userLogin ' + this.$store.state.userLogin);
      return this.$store.state.userLogin;
    }
  },
  created: function created() {
    this.buscaMenu();
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('pt-BR');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cartao-acesso',
  data: function data() {
    return {
      esconderSenha: false,
      cabecalho: {},
      usuario: {},
      resultado: {},
      titulo: 'Dados de Acesso',
      buscouCPF: false,
      emailRules: [function (value) {
        var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return !value || pattern.test(value) || 'E-mail deve ser válido';
      }],
      obrigatorioRules: [function (v) {
        return !!v || 'Campo obrigatório';
      }],
      valid: false,
      snackbar: false,
      whatsapp: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    };
  },

  components: {},
  computed: {
    logoApp: function logoApp() {
      return this.$store.state.cabecalho.logo;
    },
    cpfLimpo: function cpfLimpo() {
      if (this.resultado.cpfPaciente) {
        return this.resultado.cpfPaciente.replace(/\./g, '').replace('-', '');
      }
    },
    tituloBotaoSubmit: function tituloBotaoSubmit() {
      return this.usuario.id ? 'Atualizar Usuário' : 'Criar Usuário';
    }
  },
  watch: {
    resultado: {
      handler: function handler(val) {
        if (!val.cpfPaciente || !val.telefonePaciente) {
          this.whatsapp = false;
          val.whatsapp = false;
        }
      },
      deep: true
    },
    valid: function valid() {
      if (!this.valid) {
        this.whatsapp = false;
        console.log(this.whatsapp);
        this.resultado.whatsapp = false;
      } else if (this.resultado.cpfPaciente && this.resultado.telefonePaciente) {
        this.whatsapp = true;
      }
    }
  },
  methods: {
    moment: function moment(data) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(data);
    },
    validarMinimo: function validarMinimo(valor, minimo) {
      var valido = valor == null || valor === '';
      return !valido && valor.length < minimo ? 'Campo inválido' : true;
    },
    limparSelecao: function limparSelecao() {
      console.log(this.pagination);
    },
    detectmob: function detectmob() {
      if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
        return true;
      } else {
        return false;
      }
    },
    buscarResultado: function buscarResultado() {
      var _this = this;

      var params = 'resultado=' + this.$route.params.resultado;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/cartaoAcesso?' + params).then(function (response) {
        console.log(response.data.usuario.id);
        self.resultado = response.data.resultado;
        self.usuario = response.data.usuario;
        self.buscouCPF = response.data.usuario.id != null;
        console.log(self.buscouCPF);
        self.$store.commit('changeMenu', {
          r: _this.resultado.id
        });
      }).catch(function (e) {
        console.log(e.response.status);
        self.$router.push({ name: 'NotFound' });
      });
    },
    buscarUsuario: function buscarUsuario() {
      if (this.$refs.form.validate()) {
        var self = this;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/cartaoAcesso/usuario/' + this.cpfLimpo).then(function (response) {
          self.usuario = response.data.usuario;
          self.resultado.telefonePaciente = response.data.usuario.telefone;
          self.buscouCPF = true;
        }).catch(function (e) {
          console.log(e.response.status);
        });
      }
    },
    limpar: function limpar() {
      this.buscarResultado();
    },
    print: function print() {
      var link = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + '/cartaoAcesso/' + this.resultado.id + '?access_token=' + window.localStorage.getItem('token');
      console.log(link);
      window.open(link);
    },
    atualizar: function atualizar() {
      if (this.$refs.form.validate()) {
        var self = this;
        this.usuario.cpf = this.cpfLimpo;
        var model = {
          resultado: this.resultado,
          usuario: this.usuario
        };
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/cartaoAcesso/' + this.resultado.id, model).then(function (response) {
          self.resultado = response.data.resultado;
          self.usuario = response.data.usuario;
          self.resultado = response.data.resultado;
          self.tipoAlerta = 'success';
          self.textAlerta = 'Cartão de acesso atualizado com sucesso';
          self.snackbar = true;
        }).catch(function (e) {
          self.tipoAlerta = 'error';
          self.textAlerta = 'Erro ao atualizar cartão de acesso';
          self.snackbar = true;
        });
      }
    },
    sendMail: function sendMail() {
      console.log('email cartao');
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/emailCartao', { id: this.resultado.id }).then(function (response) {
        console.log(response);
        self.tipoAlerta = 'success';
        self.textAlerta = 'E-mail enviado com sucesso';
        self.snackbar = true;
        self.dialog = false;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Ocorreu um erro ao enviar cartão de acesso.';
        self.snackbar = true;
      });
    }
  },
  created: function created() {
    this.buscarResultado();
  },
  mounted: function mounted() {
    this.$refs.form.validate();
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empresa',
  data: function data() {
    return {
      pagination: {
        sortBy: 'nome',
        descending: 'asc',
        page: 1,
        rowsPerPage: 10
      },
      acao: 0,
      items: [],
      errors: [],
      total: null,
      titulo: 'Empresas',
      dialog: false,
      confirm: {
        title: 'Atenção',
        contentHtml: 'Tem certeza que deseja apagar a(s) empresa(s) selecionada(s).',
        ok: 'Sim',
        cancel: 'Não'
      },
      loading: true,
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: '',
      search: '',
      selected: [],
      selectAll: '',
      headers: [{
        text: 'RAZÃO SOCIAL',
        align: 'left',
        sortable: true,
        value: 'nome'
      }, {
        text: 'NOME FANTASIA',
        align: 'left',
        sortable: true,
        value: 'nomeFantasia'
      }, {
        text: 'CNPJ',
        value: 'cnpj',
        sortable: true,
        align: 'left'
      }, {
        text: 'PRODUTO',
        align: 'left',
        sortable: true,
        value: ''
      }]
    };
  },

  components: {},
  computed: {},
  watch: {
    search: function search() {
      this.$store.commit('changeEmpresaQuery', { query: this.search });
    },

    pagination: {
      handler: function handler() {
        this.atualizarLista();
      },

      deep: true
    }
  },
  methods: {
    excluir: function excluir() {
      var _this = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected).forEach(function (index) {
        var empresa = _this.selected[index];
        console.log('vai excluir ' + empresa.id);

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/empresas/' + empresa.id).then(function (response) {
          self.atualizarLista();

          self.tipoAlerta = 'success';
          self.textAlerta = 'Empresa excluído com sucesso';
          self.snackbar = true;
        }).catch(function (e) {
          self.tipoAlerta = 'error';
          self.textAlerta = 'Erro ao excluir empresa';
          self.snackbar = true;

          console.log(e);
        });

        setTimeout(function () {
          self.selected = [];
        }, 3000);

        _this.dialog = false;
      });
    },
    editar: function editar() {
      var index = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected)[0];
      var empresa = this.selected[index];
      this.$router.push({ name: 'EmpresaEdit', params: { id: empresa.id } });
    },
    pesquisar: function pesquisar() {
      this.pagination.page = 1;
      this.atualizarLista();
    },
    atualizarLista: function atualizarLista() {
      var _this2 = this;

      this.loading = true;
      var _pagination = this.pagination,
          sortBy = _pagination.sortBy,
          descending = _pagination.descending,
          page = _pagination.page,
          rowsPerPage = _pagination.rowsPerPage;

      var offset = (page - 1) * rowsPerPage;
      var porPagina = rowsPerPage;
      if (rowsPerPage !== -1 && rowsPerPage !== 5 && rowsPerPage !== 10 && rowsPerPage !== 25) {
        porPagina = 10;
      }
      var order = 'asc';
      if (!descending) {
        order = 'asc';
      }
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/empresas?sort=' + sortBy + '&order=' + order + '&offset=' + offset + '&max=' + porPagina + '&q=' + this.search).then(function (response) {
        _this2.items = response.data.list;
        _this2.total = response.data.total;
        _this2.pagination.totalItems = response.data.total;
        if (response.data.porPagina) {
          _this2.pagination.rowsPerPage = response.data.porPagina;
        }
        _this2.loading = false;
      }).catch(function (e) {
        _this2.errors.push(e);
      });
    }
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    this.search = this.$store.state.empresaQuery;
    this.atualizarLista();
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EmpresaForm__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EmpresaForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_EmpresaForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empresa-edit',
  data: function data() {
    return {
      empresa: {},
      titulo: 'Editar Empresa',
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    };
  },

  components: {
    EmpresaForm: __WEBPACK_IMPORTED_MODULE_0__components_EmpresaForm___default.a
  },
  methods: {
    loadModel: function loadModel() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/empresas/' + this.$route.params.id).then(function (response) {
        self.empresa = response.data;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao carregar empresa';
        self.snackbar = true;
      });
    },
    onSubmit: function onSubmit() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/empresas/' + this.empresa.id, this.empresa).then(function (response) {
        self.tipoAlerta = 'success';
        self.textAlerta = 'Empresa alterado com sucesso';
        self.snackbar = true;
        if (self.empresa.formData) {
          self.uploadEmpresa();
        }
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao alterar empresa';
        self.snackbar = true;
      });
    },
    uploadEmpresa: function uploadEmpresa() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function onUploadProgress(progressEvent) {
          var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
          console.log(percentCompleted);
        }
      };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/empresas/uploadEmpresa/' + this.empresa.id, this.empresa.formData, config).then(function (response) {}).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao enviar Arquivo';
        self.snackbar = true;
      });
    },
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.loadModel();
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empresa-form',
  props: {
    empresa: {}
  },
  data: function data() {
    return {
      modeloQRcodes: [],
      dialogTemplate: false
    };
  },

  components: {},
  methods: {
    popularModeloQRcode: function popularModeloQRcode() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/modeloQRcodes').then(function (response) {
        self.modeloQRcodes = response.data;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao carregar modeloQRcodes';
        self.snackbar = true;
      });
    },
    getFormData: function getFormData(files) {
      var data = new FormData();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var file = _step.value;

          data.append('files[]', file, file.name);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return data;
    },
    onFocus: function onFocus() {
      if (!this.disabled) {
        this.$refs.fileInput.click();
      }
    },
    onFocus2: function onFocus2() {
      if (!this.disabled) {
        this.$refs.fileInput2.click();
      }
    },
    onFileChange: function onFileChange($event) {
      var files = $event.target.files || $event.dataTransfer.files;
      var form = this.getFormData(files);
      if (files) {
        if (files.length > 0) {
          this.empresa.logoUrl = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)).map(function (file) {
            return file.name;
          }).join(', ');
        }
      } else {
        this.empresa.logoUrl = $event.target.value.split('\\').pop();
      }
      this.empresa.formData = form;
    },
    onFileChange2: function onFileChange2($event) {
      var files = $event.target.files || $event.dataTransfer.files;
      var form = this.getFormData(files);
      if (files) {
        if (files.length > 0) {
          this.empresa.carimboUrl = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)).map(function (file) {
            return file.name;
          }).join(', ');
        }
      } else {
        this.empresa.carimboUrl = $event.target.value.split('\\').pop();
      }
      this.empresa.formData = form;
    }
  },
  created: function created() {
    this.popularModeloQRcode();
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EmpresaForm__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EmpresaForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_EmpresaForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empresa-new',
  data: function data() {
    return {
      empresa: {},
      titulo: 'Criar Empresa',
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    };
  },

  components: {
    EmpresaForm: __WEBPACK_IMPORTED_MODULE_0__components_EmpresaForm___default.a
  },
  methods: {
    loadModel: function loadModel() {
      this.empresa = {
        nome: '',
        cnpj: '',
        intervaloStorage: '',
        cor: '',
        idSistema: '',
        assinatura: false,
        qrcode: false,
        ativa: false
      };
    },
    onSubmit: function onSubmit() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/empresas', this.empresa).then(function (response) {
        self.$store.commit('changeEmpresaQuery', { query: self.empresa.nome });
        self.$router.push({ name: 'Empresa' });
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao criar empresa ' + e;
        self.snackbar = true;
      });
    },
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.loadModel();
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    if (localStorage.getItem('user')) {
      var user = JSON.parse(localStorage.getItem('user'));
      if (user.roles && user.roles.includes('ROLE_PACIENTE')) {
        console.log('created ' + user.roles);
        this.$router.push({ name: 'ResultadoPacienteCardList' });
      }
    }
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'impressao-dialog',
  props: {
    mostrar: false,
    resultado: {}
  },
  data: function data() {
    return {
      titulo: 'Impressão de Imagens',
      valid: false,
      quantidadesPorPagina: [{ id: '2', descricao: '2 imagens por página' }, { id: '4', descricao: '4 imagens por página' }, { id: '6', descricao: '6 imagens por página' }, { id: '8', descricao: '8 imagens por página' }, { id: '9', descricao: '9 imagens por página' }, { id: '12', descricao: '12 imagens por página' }, { id: '16', descricao: '16 imagens por página' }, { id: '25', descricao: '25 imagens por página' }],
      selecaoImages: [],
      porPagina: null,
      mostraPorPagina: true,
      pular: null,
      obrigatorioRules: function obrigatorioRules(v) {
        return !!v || 'Campo obrigatório';
      }
    };
  },
  methods: {
    imprimir: function imprimir() {
      console.log('imprimir', this.resultado, this.porPagina);
      var link = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + '/imprimir/' + this.resultado.id + '?porPagina=' + this.porPagina + '&pular=' + this.pular;
      console.log(link);
      window.open(link);
      this.fechar();
    },
    fechar: function fechar() {
      this.$emit('update:mostrar', false);
    }
  },
  created: function created() {
    if (this.resultado.totalImagens && this.resultado.totalImagens < 30 || this.resultado.modalidade === 'CR' || this.resultado.modalidade === 'US') {
      this.selecaoImages.push({ id: 1, descricao: 'Todas as imagens' });
    }

    if (this.resultado.modalidade === 'CR') {
      this.quantidadesPorPagina = [{ id: '1', descricao: 'Imagem por página' }];
      this.pular = 1;
      this.porPagina = 1;
      this.mostraPorPagina = false;
    } else if (this.resultado.modalidade === 'US' || this.resultado.modalidade === 'OT') {
      this.quantidadesPorPagina.unshift({ id: '1', descricao: 'Imagem por página' });
      this.pular = 1;
    } else {
      for (var i = 2; i <= 10; i++) {
        this.selecaoImages.push({ id: i, descricao: 'Selecionar 1 a cada ' + i + ' imagens' });
      }
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_color__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_color__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: '',
      password: '',
      mostrarSenha: true,
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    };
  },

  methods: {
    login: function login() {
      var self = this;
      var redirect = self.$route.query.redirect;
      console.log('redirect ' + redirect);
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common['X-Auth-Token'] = '';
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/login', { username: this.username, password: this.password }).then(function (response) {
        console.log(response.data);
        window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
        self.$store.commit('changeUser', { user: response.data });
        if (redirect == null) {
          redirect = '/';
        }
        self.$store.commit('changeMenu', {});
        console.log('redirect ' + redirect);
        self.$router.push({ path: redirect });
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Usuário ou senha inválidos.';
        self.snackbar = true;
      });
    }
  },
  computed: {
    logoApp: function logoApp() {
      return this.$store.state.cabecalho.logo;
    },
    fundo: function fundo() {
      var cor = '#5e35b1';
      if (this.$store.state.cabecalho.cor) {
        cor = this.$store.state.cabecalho.cor;
      }
      var cor1 = __WEBPACK_IMPORTED_MODULE_2_color___default()(cor).alpha(1);
      var cor2 = __WEBPACK_IMPORTED_MODULE_2_color___default()(cor).alpha(0.7);
      var cor3 = __WEBPACK_IMPORTED_MODULE_2_color___default()(cor).alpha(1);
      return 'background: linear-gradient(' + cor1 + ' 1%, ' + cor2 + ' 50%, ' + cor3 + ' 99%), center center, url(/static/bg_01.jpg);';
    }
  },
  created: function created() {
    console.log('redirect ' + this.$route.query.redirect);
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('pt-BR');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'medicos',
  data: function data() {
    return {
      pagination: {
        sortBy: 'nome',
        descending: 'asc',
        page: 1,
        rowsPerPage: 10
      },
      today: new Date(),
      dialog: false,
      confirm: {
        title: 'Atenção',
        contentHtml: 'Tem certeza que deseja apagar o(s) médico(s) selecionado(s).',
        ok: 'Sim',
        cancel: 'Não'
      },
      loading: true,
      titulo: 'Médicos',
      items: [],
      errors: [],
      total: null,
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: '',
      search: '',
      selected: [],
      selectAll: '',
      headers: [{
        text: 'NOME',
        align: 'left',
        sortable: true,
        value: 'nome'
      }, { text: 'CPF',
        value: 'cpf',
        sortable: true,
        align: 'left'
      }, {
        text: 'CRM',
        value: 'crm',
        sortable: true,
        align: 'left'
      }, {
        text: 'CERTIFICADO DIGITAL',
        value: 'dataVencimentoCertificado',
        sortable: true,
        align: 'left'
      }]
    };
  },

  components: {},
  computed: {},
  watch: {
    search: function search() {
      this.$store.commit('changeMedicoQuery', { query: this.search });
    },

    pagination: {
      handler: function handler() {
        this.atualizarLista();
      },

      deep: true
    }
  },
  methods: {
    moment: function moment(data) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(data);
    },
    excluir: function excluir() {
      var _this = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected).forEach(function (index) {
        var medico = _this.selected[index];
        console.log('vai excluir ' + medico.id);

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/medicos/' + medico.id).then(function (response) {
          self.atualizarLista();

          self.tipoAlerta = 'success';
          self.textAlerta = 'Médico excluído com sucesso';
          self.snackbar = true;
        }).catch(function (e) {
          self.tipoAlerta = 'error';
          self.textAlerta = 'Erro ao excluir Médico';
          self.snackbar = true;

          console.log(e);
        });

        setTimeout(function () {
          self.selected = [];
        }, 3000);

        _this.dialog = false;
      });
    },
    editar: function editar() {
      var index = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected)[0];
      var medico = this.selected[index];
      this.$router.push({ name: 'MedicoEdit', params: { id: medico.id } });
    },
    pesquisar: function pesquisar() {
      this.pagination.page = 1;
      this.atualizarLista();
    },
    atualizarLista: function atualizarLista() {
      var _this2 = this;

      this.loading = true;
      var _pagination = this.pagination,
          sortBy = _pagination.sortBy,
          descending = _pagination.descending,
          page = _pagination.page,
          rowsPerPage = _pagination.rowsPerPage;

      var offset = (page - 1) * rowsPerPage;
      var porPagina = rowsPerPage;
      if (rowsPerPage !== -1 && rowsPerPage !== 5 && rowsPerPage !== 10 && rowsPerPage !== 25) {
        porPagina = 10;
      }
      var order = 'asc';
      if (!descending) {
        order = 'asc';
      }
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/medicos?sort=' + sortBy + '&order=' + order + '&offset=' + offset + '&max=' + porPagina + '&q=' + this.search).then(function (response) {
        _this2.items = response.data.list;
        _this2.total = response.data.total;
        _this2.pagination.totalItems = response.data.total;
        if (response.data.porPagina) {
          _this2.pagination.rowsPerPage = response.data.porPagina;
        }
        _this2.loading = false;
      }).catch(function (e) {
        _this2.errors.push(e);
      });
    }
  },

  created: function created() {
    this.search = this.$store.state.medicoQuery;
    this.atualizarLista();
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MedicoForm__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MedicoForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MedicoForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'medico-edit',
  data: function data() {
    return {
      medico: {},
      titulo: 'Editar Médico',
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    };
  },

  components: {
    MedicoForm: __WEBPACK_IMPORTED_MODULE_0__components_MedicoForm___default.a
  },
  methods: {
    loadModel: function loadModel() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/medicos/' + this.$route.params.id).then(function (response) {
        self.medico = response.data;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao carregar médico';
        self.snackbar = true;
      });
    },
    onSubmit: function onSubmit() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/medicos/' + this.medico.id, this.medico).then(function (response) {
        self.tipoAlerta = 'success';
        self.textAlerta = 'Médico alterado com sucesso';
        self.snackbar = true;
        if (self.medico.formData) {
          self.uploadc();
        }
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao alterar médico';
        self.snackbar = true;
      });
    },
    uploadc: function uploadc() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function onUploadProgress(progressEvent) {
          var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
          console.log(percentCompleted);
        }
      };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/medicos/uploadc/' + this.medico.id, this.medico.formData, config).then(function (response) {}).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao enviar Certificado';
        self.snackbar = true;
      });
    },
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.loadModel();
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('pt-BR');

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'medico-form',
  props: {
    medico: {}
  },
  data: function data() {
    return {
      mostrarSenha: true
    };
  },

  components: {},
  computed: {
    dataVencimentoCertificado: function dataVencimentoCertificado() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.medico.dataVencimentoCertificado).format('DD/MM/YYYY hh:mm');
    }
  },
  methods: {
    getFormData: function getFormData(files) {
      var data = new FormData();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var file = _step.value;

          data.append('files[]', file, file.name);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return data;
    },
    onFocus: function onFocus() {
      if (!this.disabled) {
        this.$refs.fileInput.click();
      }
    },
    onFileChange: function onFileChange($event) {
      var files = $event.target.files || $event.dataTransfer.files;
      var form = this.getFormData(files);
      if (files) {
        if (files.length > 0) {
          this.medico.certificado = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)).map(function (file) {
            return file.name;
          }).join(', ');
        }
      } else {
        this.medico.certificado = $event.target.value.split('\\').pop();
      }
      this.medico.formData = form;
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MedicoForm__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MedicoForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MedicoForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'medico-new',
  data: function data() {
    return {
      medico: {},
      titulo: 'Criar Médico',
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    };
  },

  components: {
    MedicoForm: __WEBPACK_IMPORTED_MODULE_0__components_MedicoForm___default.a
  },
  methods: {
    loadModel: function loadModel() {
      this.medico = {
        nome: '',
        cpf: '',
        ativo: false
      };
    },
    onSubmit: function onSubmit() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/medicos', this.medico).then(function (response) {
        self.$store.commit('changeMedicoQuery', { query: self.medico.nome });
        self.$router.push({ name: 'Medico' });
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao criar médico ' + e;
        self.snackbar = true;
      });
    },
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.loadModel();
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'menu',
  data: function data() {
    return {
      acao: 0,
      items: [],
      errors: [],
      total: null,
      titulo: 'Menus',
      dialog: false,
      confirm: {
        title: 'Atenção',
        contentHtml: 'Tem certeza que deseja apagar a(s) menu(s) selecionada(s).',
        ok: 'Sim',
        cancel: 'Não'
      },
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: '',
      search: '',
      selected: [],
      selectAll: '',
      headers: [{
        text: 'Título',
        align: 'left',
        sortable: true,
        value: 'title'
      }, { text: 'Permissão',
        sortable: false,
        value: 'permissoes',
        align: 'left'
      }]
    };
  },

  components: {},
  computed: {},
  watch: {
    search: function search() {
      this.$store.commit('changeMenuQuery', { query: this.search });
    }
  },
  methods: {
    limparSelecao: function limparSelecao() {
      console.log(this.pagination);
    },
    excluir: function excluir() {
      var _this = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected).forEach(function (index) {
        var menu = _this.selected[index];
        console.log('vai excluir ' + menu.id);

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/menus/' + menu.id).then(function (response) {
          self.atualizarLista();

          self.tipoAlerta = 'success';
          self.textAlerta = 'Menu excluído com sucesso';
          self.snackbar = true;
        }).catch(function (e) {
          self.tipoAlerta = 'error';
          self.textAlerta = 'Erro ao excluir menu';
          self.snackbar = true;

          console.log(e);
        });

        setTimeout(function () {
          self.selected = [];
        }, 3000);

        _this.dialog = false;
      });
    },
    editar: function editar() {
      var index = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected)[0];
      var menu = this.selected[index];
      this.$router.push({ name: 'MenuEdit', params: { id: menu.id } });
    },
    atualizarLista: function atualizarLista() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/menus?sort=ordem&order=asc&offset=0&max=1000').then(function (response) {
        _this2.items = response.data.list;
        _this2.total = response.data.total;
      }).catch(function (e) {
        _this2.errors.push(e);
      });
    }
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    this.search = this.$store.state.menuQuery;
    this.atualizarLista();
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MenuForm__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MenuForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MenuForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'menu-edit',
  data: function data() {
    return {
      menu: {},
      itemsPermissoes: [],
      titulo: 'Editar Menu',
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    };
  },

  components: {
    MenuForm: __WEBPACK_IMPORTED_MODULE_0__components_MenuForm___default.a
  },
  methods: {
    loadModel: function loadModel() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/menus/' + this.$route.params.id).then(function (response) {
        self.menu = response.data;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao carregar menu';
        self.snackbar = true;
      });
    },
    onSubmit: function onSubmit() {
      var self = this;
      if (!this.menu.password) {
        delete this.menu.password;
      }
      console.log(this.menu);
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/menus/' + this.menu.id, this.menu).then(function (response) {
        console.log(response);
        self.tipoAlerta = 'success';
        self.textAlerta = 'Menu alterado com sucesso';
        self.snackbar = true;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        if (e.response) {
          self.textAlerta = e.response.data.message;
        } else {
          self.textAlerta = 'Erro ao criar menu';
        }
        self.snackbar = true;
      });
    },
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.loadModel();
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'menu-form',
  props: {
    menu: {}
  },
  data: function data() {
    return {
      mostrarSenha: true,
      itemsPermissoes: [],
      itemsMenu: [],
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    };
  },

  components: {},
  methods: {
    pupularPermissoes: function pupularPermissoes() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/permissoes').then(function (response) {
        self.itemsPermissoes = response.data.list;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao carregar permissões';
        self.snackbar = true;
      });
    },
    pupularMenu: function pupularMenu() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/menus?semFilhos=s').then(function (response) {
        self.itemsMenu = response.data.list;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao carregar menu';
        self.snackbar = true;
      });
    }
  },
  created: function created() {
    this.pupularPermissoes();
    this.pupularMenu();
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MenuForm__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MenuForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MenuForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'menu-new',
  data: function data() {
    return {
      menu: {},
      titulo: 'Criar Menu',
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    };
  },

  components: {
    MenuForm: __WEBPACK_IMPORTED_MODULE_0__components_MenuForm___default.a
  },
  methods: {
    loadModel: function loadModel() {
      this.menu = {
        nome: '',
        cpf: '',
        ativo: false
      };
    },
    onSubmit: function onSubmit() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/menus', this.menu).then(function (response) {
        self.$store.commit('changeMenuQuery', { query: self.menu.nome });
        self.$router.push({ name: 'Menu' });
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        if (e.response) {
          self.textAlerta = e.response.data.message;
        } else {
          self.textAlerta = 'Erro ao criar usuário';
        }
        self.snackbar = true;
      });
    },
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.loadModel();
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notfound',
  data: function data() {
    return {
      mensagem: 'A página que você deseja acessar não existe.'
    };
  },

  components: {},
  computed: {},
  methods: {},
  created: function created() {}
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'pdf-dialog',
  props: {
    resultado: {},
    display: false,
    link: ''
  },
  data: function data() {
    return {
      dialogPdf: false,
      loaded: false,
      linkPdf: '',
      linkDownload: ''
    };
  },

  components: {},
  watch: {
    display: function display(value) {
      this.dialogPdf = value;
      if (value) {
        this.carregarIframe();
      }
    }
  },
  methods: {
    close: function close() {
      this.dialogPdf = false;
      this.loaded = false;
      this.$emit('update:display', false);
    },
    carregarIframe: function carregarIframe() {
      var self = this;
      if (self.loaded || !this.dialogPdf) {
        return;
      }
      console.log('carregarIframe ---- > ', this.loaded, this.link);
      var iframeContext = document.getElementById('iframeContext_' + this.resultado.id);
      iframeContext.innerText = '';
      if (this.link) {
        this.linkDownload = this.link.substr(this.link.indexOf('https://st'));
        console.log('this.linkDownload ' + this.linkDownload);
        console.log('iframe link ' + this.link);
        console.log('id ', this.resultado);
        var iframe = document.createElement('iframe');
        iframe.frameBorder = 0;
        iframe.width = '100%';
        iframe.height = '100%';
        iframeContext.appendChild(iframe);

        iframe.src = this.link;

        iframe.onload = function () {
          self.loaded = true;
          console.log('carregou!!', self.loaded);
        };
        setTimeout(this.carregarIframe, 3000);
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {}
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_color__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_color__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      username: '',
      password: '',
      validEmail: false,
      mostrarSenha: true,
      email: '',
      snackbar: false,
      tipoAlerta: '',
      textAlerta: '',
      senha: '',
      csenha: '',
      usuarioLogado: null,
      timeoutAlerta: 6000,
      sucesso: false,
      mensagem: '',
      valid: false,
      validUsuario: false,
      emailCode: false,
      senhaRules: [function (v) {
        return !!v || 'Senha obrigatória';
      }, function (v) {
        return !!v && v.length >= 8 || 'A senha deve ter no mínimo 8 caracteres';
      }],
      csenhaRules: [function (v) {
        return !!v || 'Confirmação de Senha obrigatória';
      }, function () {
        return _this.senha === _this.csenha || 'As senhas devem ser iguais';
      }],
      emailRules: [function (v) {
        return !!v || 'E-mail é obrigatório';
      }, function (value) {
        var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'E-mail deve ser válido';
      }]
    };
  },

  watch: {
    email: function email() {
      this.$refs.formEmail.validate();
    }
  },
  methods: {
    loadModel: function loadModel() {
      var self = this;
      if (this.$route.params.code) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/emailCode/' + this.$route.params.code).then(function (response) {
          self.emailCode = response.data;
          if (self.emailCode.dataAlteracao) {
            self.mensagem = 'Senha alterada com sucesso!';
          }
        }).catch(function (error) {
          self.mensagem = error.response.data.message;
        });
      }

      if (this.usuario) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/usuarioLogado').then(function (response) {
          self.usuarioLogado = response.data;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    solicitarAlteracao: function solicitarAlteracao() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/emailCode', { email: this.email }).then(function (response) {
        console.log(response.data);
        self.mensagem = 'Verifique o e-mail e siga o procedimento para alteração da senha!';
        self.sucesso = true;
      }).catch(function (e) {});
    },
    trocarSenha: function trocarSenha() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['X-Auth-Token'] = '';
      var params = { senha: this.senha, csenha: this.csenha };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/emailCode/' + this.emailCode.id, params).then(function (response) {
        console.log(response.data);

        self.mensagem = 'Senha alterada com sucesso!';
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro durante a alteração da senha.';
        self.snackbar = true;
      });
    },
    trocarSenhaLogado: function trocarSenhaLogado() {
      var self = this;
      var params = { password: this.password, senha: this.senha, csenha: this.csenha };
      if (this.email) {
        params['email'] = this.email;
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/updatePassword', params).then(function (response) {
        console.log(response.data);
        self.$router.push({ path: '/login' });
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro durante a alteração da senha.';
        self.snackbar = true;
      });
    }
  },
  computed: {
    logoApp: function logoApp() {
      return this.$store.state.cabecalho.logo;
    },
    fundo: function fundo() {
      var cor = '#5e35b1';
      if (this.$store.state.cabecalho.cor) {
        cor = this.$store.state.cabecalho.cor;
      }
      var cor1 = __WEBPACK_IMPORTED_MODULE_1_color___default()(cor).alpha(1);
      var cor2 = __WEBPACK_IMPORTED_MODULE_1_color___default()(cor).alpha(0.7);
      var cor3 = __WEBPACK_IMPORTED_MODULE_1_color___default()(cor).alpha(1);
      return 'background: linear-gradient(' + cor1 + ' 1%, ' + cor2 + ' 50%, ' + cor3 + ' 99%), center center, url(/static/bg_01.jpg);';
    },
    usuario: function usuario() {
      return this.$store.state.userLogin;
    }
  },
  created: function created() {
    console.log('redirect ' + this.$route.query.redirect);
    this.loadModel();
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PdfDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PdfDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PdfDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ViewerDialog__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ViewerDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ViewerDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ImpressaoDialog__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ImpressaoDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ImpressaoDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);








__WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale('pt-BR');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'resultado-card',
  props: {
    resultado: {}
  },
  data: function data() {
    return {
      items: [],
      errors: [],
      total: null,
      cabecalho: {},
      titulo: 'Resultados',
      dialogPdf: false,
      dialogViewer: false,
      dialogImpressao: false,
      linkViewer: null,
      linkPdf: null,
      share: {},
      dialog: false,
      email: null,
      emailRules: [function (v) {
        return !!v || 'E-mail obrigatório';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail inválido'
        );
      }],
      valid: false,
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    };
  },

  components: {
    PdfDialog: __WEBPACK_IMPORTED_MODULE_0__components_PdfDialog___default.a,
    ViewerDialog: __WEBPACK_IMPORTED_MODULE_1__components_ViewerDialog___default.a,
    ImpressaoDialog: __WEBPACK_IMPORTED_MODULE_2__components_ImpressaoDialog___default.a
  },
  computed: {
    linkWpp: function linkWpp() {
      return 'whatsapp://send?text=' + this.textSocial;
    },
    nomeFantasia: function nomeFantasia() {
      var nome = this.resultado.empresa.nomeFantasia ? this.resultado.empresa.nomeFantasia : this.resultado.empresa.nome;
      if (this.resultado.unidade.id) {
        nome = this.resultado.unidade.nomeFantasia ? this.resultado.unidade.nomeFantasia : this.resultado.unidade.nome;
      }
      return nome;
    },
    textSocial: function textSocial() {
      var br = '\r\n';

      var message = '*' + this.resultado.empresa.nome + '* ';

      message += br + br + ('O paciente *' + this.resultado.nomePaciente + '* compartilhou o resultado do exame *' + this.resultado.tipoExame + '* ( *' + this.resultado.modalidade + '* ) feito na empresa *' + this.resultado.empresa.nome + '* com voc\xEA.');
      message += br + br + 'Para visualizar as imagens e o laudo digital acesse o através das informações abaixo:';

      message += br + br + ('Usu\xE1rio: *' + this.share.username + '*');
      message += br + ('Senha: *' + this.share.password + '*');
      message += br + ('Link do Resultado: ' + this.share.link);
      message += br + br + this.share.dataValidade;

      return encodeURIComponent(message);
    }
  },
  methods: {
    moment: function moment(data) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(data);
    },
    limparSelecao: function limparSelecao() {
      console.log(this.pagination);
    },
    openPdf: function openPdf(res) {
      this.dialogPdf = true;
      var link = null;
      this.resultado = res;
      if (res) {
        var idConnect = res.idConnect ? res.idConnect : 'laudos';
        if (res.dataAssinatura) {
          link = 'https://docs.google.com/viewer?embedded=true&url=https://storage.googleapis.com/' + res.intervaloStorage + '/' + idConnect + '/' + res.id + '_signed.pdf';
        } else {
          link = 'https://docs.google.com/viewer?embedded=true&url=https://storage.googleapis.com/' + res.intervaloStorage + '/' + idConnect + '/' + res.id + '_add.pdf';
        }

        console.log('link??', link);
        this.linkPdf = link;
      }
    },
    detectmob: function detectmob() {
      if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
        return true;
      } else {
        return false;
      }
    },
    compartilharWhatsapp: function compartilharWhatsapp(link) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/compartilhar', this.resultado).then(function (response) {
        self.share = response.data.info;
        self.resultado.share = response.data.info;
        console.log(self.resultado);
        if (self.share) {
          window.location.href = self.linkWpp;
          self.dialog = false;
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    compartilharEmail: function compartilharEmail() {
      console.log('share');
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/email', { resultado: this.resultado, email: this.email }).then(function (response) {
        self.share = response.data;
        console.log(self.share);
        if (self.share) {
          self.tipoAlerta = 'success';
          self.textAlerta = 'E-mail enviado com sucesso para ' + self.share.email;
          self.snackbar = true;
          self.dialog = false;
        }
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Ocorreu um erro ao compartilhar resultado.';
        self.snackbar = true;
      });
    },
    buscarImage: function buscarImage(res) {
      var link = 'https://storage.googleapis.com/' + res.intervaloStorage + '/' + res.idConnect + '/capa.jpg';
      return link;
    },
    openViewer: function openViewer(res) {
      this.buscarImage(res);
      console.log(res);
      if (res) {
        if (this.detectmob()) {
          link = 'https://mviewer.mezzow.com/mindex.html?eid=' + res.idConnect + '&st=' + res.intervaloStorage + '&em=' + res.email;
          window.open(link, res.idConnect);
        } else {
          this.dialogViewer = true;
          var link = null;
          this.resultado = res;
          link = 'https://mviewer.mezzow.com/index.html?eid=' + res.idConnect + '&st=' + res.intervaloStorage + '&em=' + res.email;
          this.linkViewer = link;
        }
      }
    }
  },
  created: function created() {}
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PdfDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PdfDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PdfDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ViewerDialog__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ViewerDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ViewerDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ImpressaoDialog__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ImpressaoDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ImpressaoDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);









__WEBPACK_IMPORTED_MODULE_5_moment___default.a.locale('pt-BR');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'resultados',
  data: function data() {
    return {
      pagination: {
        sortBy: 'dataCadastro',
        descending: 'desc',
        page: 1,
        rowsPerPage: 10
      },
      loading: true,
      items: [],
      errors: [],
      total: null,
      titulo: 'Resultados',
      dialogPdf: false,
      dialogViewer: false,
      dialogImpressao: false,
      linkViewer: null,
      linkPdf: null,
      dialog: false,
      confirm: {
        title: 'Atenção',
        contentHtml: 'Tem certeza que deseja apagar os exame(s) selecionado(s).',
        ok: 'Sim',
        cancel: 'Não'
      },
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: '',
      search: '',
      selected: [],
      selectAll: '',
      headers: [{
        text: 'Cadastro',
        align: 'left',
        sortable: true,
        value: 'dataCadastro'
      }, {
        text: 'Exame',
        align: 'left',
        sortable: true,
        value: 'idExame'
      }, {
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'nomePaciente'
      }, { text: 'CPF',
        value: 'cpfPaciente',
        align: 'left'
      }, { text: 'Empresa',
        value: 'cnpjEmpresa',
        align: 'left'
      }, { text: 'Data Assinatura',
        value: 'dataAssinatura',
        align: 'left'
      }, { text: 'Médico Assinatura',
        value: 'cpfAssinatura',
        align: 'left'
      }]
    };
  },

  components: {
    PdfDialog: __WEBPACK_IMPORTED_MODULE_1__components_PdfDialog___default.a,
    ViewerDialog: __WEBPACK_IMPORTED_MODULE_2__components_ViewerDialog___default.a,
    ImpressaoDialog: __WEBPACK_IMPORTED_MODULE_3__components_ImpressaoDialog___default.a
  },
  computed: {
    linkResultado: function linkResultado() {
      var link = null;
      var index = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected)[0];
      var res = this.selected[index];
      console.log(res);
      if (res) {
        link = '#/resultado/' + res.id;
      }
      return link;
    },
    linkCartaoAcesso: function linkCartaoAcesso() {
      var link = null;
      var index = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected)[0];
      var res = this.selected[index];
      console.log(res);
      if (res) {
        link = '#/cartao-acesso/' + res.id;
      }
      return link;
    },
    resultado: function resultado() {
      var index = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected)[0];
      var res = this.selected[index];
      console.log(res);
      return res;
    }
  },
  watch: {
    search: function search() {
      this.$store.commit('changeMedicoQuery', { query: this.search });
    },

    pagination: {
      handler: function handler() {
        this.atualizarLista();
      },

      deep: true
    }
  },
  methods: {
    moment: function moment(data) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(data);
    },
    excluir: function excluir() {
      var _this = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected).forEach(function (index) {
        var resultado = _this.selected[index];
        console.log('vai excluir ' + resultado.id);

        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('/resultados/' + resultado.id).then(function (response) {
          self.atualizarLista();

          self.tipoAlerta = 'success';
          self.textAlerta = 'Resultado excluído com sucesso';
          self.snackbar = true;
        }).catch(function (e) {
          self.tipoAlerta = 'error';
          self.textAlerta = 'Erro ao excluir resultado';
          self.snackbar = true;

          console.log(e);
        });

        setTimeout(function () {
          self.selected = [];
        }, 3000);

        _this.dialog = false;
      });
    },
    openPdf: function openPdf() {
      this.dialogPdf = true;
      var link = null;
      var index = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected)[0];
      var res = this.selected[index];
      if (res) {
        var idConnect = res.idConnect ? res.idConnect : 'laudos';
        if (res.dataAssinatura) {
          link = 'https://docs.google.com/viewer?embedded=true&url=https://storage.googleapis.com/' + res.intervaloStorage + '/' + idConnect + '/' + res.id + '_signed.pdf';
        } else {
          link = 'https://docs.google.com/viewer?embedded=true&url=https://storage.googleapis.com/' + res.intervaloStorage + '/' + idConnect + '/' + res.id + '_add.pdf';
        }
        this.linkPdf = link;
      }
    },
    detectmob: function detectmob() {
      if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
        return true;
      } else {
        return false;
      }
    },
    openViewer: function openViewer() {
      var index = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected)[0];
      var res = this.selected[index];
      console.log(res);
      if (res) {
        if (this.detectmob()) {
          link = 'https://mviewer.mezzow.com/mindex.html?eid=' + res.idConnect + '&st=' + res.intervaloStorage + '&em=' + res.email;
          window.open(link, res.idConnect);
        } else {
          this.dialogViewer = true;
          var link = null;
          this.resultado = res;
          link = 'https://mviewer.mezzow.com/index.html?eid=' + res.idConnect + '&st=' + res.intervaloStorage + '&em=' + res.email;
          this.linkViewer = link;
        }
      }
    },
    editar: function editar() {
      var index = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected)[0];
      var medico = this.selected[index];
      this.$router.push({ name: 'MedicoEdit', params: { id: medico.id } });
    },
    abrirCartao: function abrirCartao() {
      var index = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected)[0];
      var resultado = this.selected[index];
      this.$router.push({ name: 'CartaoAcesso', params: { resultado: resultado.id } });
    },
    pesquisar: function pesquisar() {
      this.pagination.page = 1;
      this.atualizarLista();
    },
    atualizarLista: function atualizarLista() {
      var _this2 = this;

      this.loading = true;
      var _pagination = this.pagination,
          sortBy = _pagination.sortBy,
          descending = _pagination.descending,
          page = _pagination.page,
          rowsPerPage = _pagination.rowsPerPage;

      var offset = (page - 1) * rowsPerPage;
      var porPagina = rowsPerPage;
      if (rowsPerPage !== -1 && rowsPerPage !== 5 && rowsPerPage !== 10 && rowsPerPage !== 25) {
        porPagina = 10;
      }
      var order = 'desc';
      if (!descending) {
        order = 'asc';
      }
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/resultados?sort=' + sortBy + '&order=' + order + '&offset=' + offset + '&max=' + porPagina + '&q=' + this.search).then(function (response) {
        _this2.items = response.data.list;
        _this2.total = response.data.total;
        _this2.pagination.totalItems = response.data.total;
        if (response.data.porPagina) {
          _this2.pagination.rowsPerPage = response.data.porPagina;
        }
        _this2.loading = false;
      }).catch(function (e) {
        _this2.errors.push(e);
      });
    }
  },

  created: function created() {
    this.search = this.$store.state.medicoQuery;
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ResultadoCard__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ResultadoCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ResultadoCard__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'resultados-paciente',
  data: function data() {
    return {
      resultado: {}
    };
  },

  components: {
    ResultadoCard: __WEBPACK_IMPORTED_MODULE_1__components_ResultadoCard___default.a
  },
  methods: {
    atualizarLista: function atualizarLista() {
      var _this = this;

      var params = 'resultado=' + this.$route.params.resultado;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/resultado?' + params).then(function (response) {
        _this.resultado = response.data.resultado;
        _this.$store.commit('changeMenu', {
          r: _this.resultado.id
        });
      }).catch(function (e) {
        console.log(e.response.status);
        _this.$router.push({ name: 'NotFound' });
      });
    }
  },
  created: function created() {
    this.atualizarLista();
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ResultadoCard__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ResultadoCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ResultadoCard__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'resultado-paciente-card',
  data: function data() {
    return {
      resultados: {}
    };
  },

  components: {
    ResultadoCard: __WEBPACK_IMPORTED_MODULE_1__components_ResultadoCard___default.a
  },
  methods: {
    atualizarLista: function atualizarLista() {
      var _this = this;

      var params = 'a=a';
      if (this.$route.params.cpf) {
        params += '&cpfPaciente=' + this.$route.params.cpf;
      }
      if (this.$route.params.empresa) {
        params += '&empresa=' + this.$route.params.empresa;
      }
      if (this.$route.params.exame) {
        params += '&exame=' + this.$route.params.exame;
      }
      if (this.$route.params.resultado) {
        params += '&resultado=' + this.$route.params.resultado;
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/rp?' + params).then(function (response) {
        _this.resultados = response.data.list;
        _this.$store.commit('changeCabecalho', { cabecalho: response.data.cabecalho });
      }).catch(function (e) {
        _this.$router.push({ name: 'NotFound' });
      });
    }
  },
  created: function created() {
    this.atualizarLista();
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PdfDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PdfDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PdfDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ViewerDialog__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ViewerDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ViewerDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







__WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('pt-BR');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'resultadoShareCard',
  data: function data() {
    return {
      items: [],
      errors: [],
      total: null,
      cabecalho: {},
      resultado: {},
      titulo: 'Resultados',
      dialogPdf: false,
      dialogViewer: false,
      linkViewer: null,
      linkPdf: null
    };
  },

  components: {
    PdfDialog: __WEBPACK_IMPORTED_MODULE_0__components_PdfDialog___default.a,
    ViewerDialog: __WEBPACK_IMPORTED_MODULE_1__components_ViewerDialog___default.a
  },
  computed: {},
  methods: {
    moment: function moment(data) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(data);
    },
    limparSelecao: function limparSelecao() {
      console.log(this.pagination);
    },
    openPdf: function openPdf(res) {
      this.dialogPdf = true;
      var link = null;
      this.resultado = res;
      if (res) {
        var idConnect = res.idConnect ? res.idConnect : 'laudos';
        if (res.dataAssinatura) {
          link = 'https://docs.google.com/viewer?embedded=true&url=https://storage.googleapis.com/' + res.intervaloStorage + '/' + idConnect + '/' + res.id + '_signed.pdf';
        } else {
          link = 'https://docs.google.com/viewer?embedded=true&url=https://storage.googleapis.com/' + res.intervaloStorage + '/' + idConnect + '/' + res.id + '_add.pdf';
        }
        this.linkPdf = link;
      }
    },
    detectmob: function detectmob() {
      if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
        return true;
      } else {
        return false;
      }
    },
    buscarImage: function buscarImage(res) {
      var link = 'https://storage.googleapis.com/' + res.intervaloStorage + '/' + res.idConnect + '/capa.jpg';
      return link;
    },
    openViewer: function openViewer(res) {
      this.buscarImage(res);
      console.log(res);
      if (res) {
        if (this.detectmob()) {
          link = 'https://mviewer.mezzow.com/mindex.html?eid=' + res.idConnect + '&st=' + res.intervaloStorage + '&em=' + res.empresa.email;
          window.open(link, res.idConnect);
        } else {
          this.dialogViewer = true;
          var link = null;
          this.resultado = res;
          link = 'https://mviewer.mezzow.com/index.html?eid=' + res.idConnect + '&st=' + res.intervaloStorage + '&em=' + res.empresa.email;
          this.linkViewer = link;
        }
      }
    },
    atualizarLista: function atualizarLista() {
      var _this = this;

      var params = 'id=' + this.$route.params.share;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/shared?' + params).then(function (response) {
        _this.resultado = response.data.resultado;
        _this.$store.commit('changeCabecalho', { cabecalho: response.data.cabecalho });
      }).catch(function (e) {
        if (e.response.status === 403) {} else {
          _this.$router.push({ name: 'NotFound' });
        }
      });
    }
  },

  created: function created() {
    this.atualizarLista();
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'unidade',
  data: function data() {
    return {
      acao: 0,
      items: [],
      errors: [],
      total: null,
      titulo: 'Unidades',
      dialog: false,
      confirm: {
        title: 'Atenção',
        contentHtml: 'Tem certeza que deseja apagar a(s) unidade(s) selecionada(s).',
        ok: 'Sim',
        cancel: 'Não'
      },
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: '',
      search: '',
      selected: [],
      selectAll: '',
      headers: [{
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'nome'
      }, {
        text: 'Empresa',
        align: 'left',
        sortable: true,
        value: 'empresa.nome'
      }, { text: 'CNPJ',
        value: 'cnpj',
        align: 'left'
      }]
    };
  },

  components: {},
  computed: {},
  watch: {
    search: function search() {
      this.$store.commit('changeUnidadeQuery', { query: this.search });
    }
  },
  methods: {
    limparSelecao: function limparSelecao() {
      console.log(this.pagination);
    },
    excluir: function excluir() {
      var _this = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected).forEach(function (index) {
        var unidade = _this.selected[index];
        console.log('vai excluir ' + unidade.id);

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/unidades/' + unidade.id).then(function (response) {
          self.atualizarLista();

          self.tipoAlerta = 'success';
          self.textAlerta = 'Unidade excluído com sucesso';
          self.snackbar = true;
        }).catch(function (e) {
          self.tipoAlerta = 'error';
          self.textAlerta = 'Erro ao excluir unidade';
          self.snackbar = true;

          console.log(e);
        });

        setTimeout(function () {
          self.selected = [];
        }, 3000);

        _this.dialog = false;
      });
    },
    editar: function editar() {
      var index = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected)[0];
      var unidade = this.selected[index];
      this.$router.push({ name: 'UnidadeEdit', params: { id: unidade.id } });
    },
    atualizarLista: function atualizarLista() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/unidades?sort=nome&order=asc&offset=0&max=1000').then(function (response) {
        _this2.items = response.data.list;
        _this2.total = response.data.total;
      }).catch(function (e) {
        _this2.errors.push(e);
      });
    }
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    this.search = this.$store.state.unidadeQuery;
    this.atualizarLista();
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UnidadeForm__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UnidadeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_UnidadeForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'unidade-edit',
  data: function data() {
    return {
      unidade: {},
      titulo: 'Editar Unidade',
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    };
  },

  components: {
    UnidadeForm: __WEBPACK_IMPORTED_MODULE_0__components_UnidadeForm___default.a
  },
  methods: {
    loadModel: function loadModel() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/unidades/' + this.$route.params.id).then(function (response) {
        self.unidade = response.data;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao carregar unidade';
        self.snackbar = true;
      });
    },
    onSubmit: function onSubmit() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/unidades/' + this.unidade.id, this.unidade).then(function (response) {
        self.tipoAlerta = 'success';
        self.textAlerta = 'Unidade alterado com sucesso';
        self.snackbar = true;
        if (self.unidade.formData) {
          self.uploadUnidade();
        }
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao alterar unidade';
        self.snackbar = true;
      });
    },
    uploadUnidade: function uploadUnidade() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function onUploadProgress(progressEvent) {
          var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
          console.log(percentCompleted);
        }
      };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/unidades/uploadUnidade/' + this.unidade.id, this.unidade.formData, config).then(function (response) {}).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao enviar Arquivo';
        self.snackbar = true;
      });
    },
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.loadModel();
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'unidade-form',
  props: {
    unidade: {}
  },
  data: function data() {
    return {
      empresas: [],
      modeloQRcodes: []
    };
  },

  components: {},
  methods: {
    pupularEmpresas: function pupularEmpresas() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/empresas').then(function (response) {
        self.empresas = response.data.list;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao carregar empresas';
        self.snackbar = true;
      });
    },
    popularModeloQRcode: function popularModeloQRcode() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/modeloQRcodes').then(function (response) {
        self.modeloQRcodes = response.data;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao carregar modeloQRcodes';
        self.snackbar = true;
      });
    },
    getFormData: function getFormData(files) {
      var data = new FormData();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var file = _step.value;

          data.append('files[]', file, file.name);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return data;
    },
    onFocus: function onFocus() {
      if (!this.disabled) {
        this.$refs.fileInput.click();
      }
    },
    onFocus2: function onFocus2() {
      if (!this.disabled) {
        this.$refs.fileInput2.click();
      }
    },
    onFileChange: function onFileChange($event) {
      var files = $event.target.files || $event.dataTransfer.files;
      var form = this.getFormData(files);
      if (files) {
        if (files.length > 0) {
          this.unidade.logoUrl = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)).map(function (file) {
            return file.name;
          }).join(', ');
        }
      } else {
        this.unidade.logoUrl = $event.target.value.split('\\').pop();
      }
      this.unidade.formData = form;
    },
    onFileChange2: function onFileChange2($event) {
      var files = $event.target.files || $event.dataTransfer.files;
      var form = this.getFormData(files);
      if (files) {
        if (files.length > 0) {
          this.unidade.carimboUrl = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)).map(function (file) {
            return file.name;
          }).join(', ');
        }
      } else {
        this.unidade.carimboUrl = $event.target.value.split('\\').pop();
      }
      this.unidade.formData = form;
    }
  },
  created: function created() {
    this.pupularEmpresas();
    this.popularModeloQRcode();
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UnidadeForm__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UnidadeForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_UnidadeForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'unidade-new',
  data: function data() {
    return {
      unidade: {},
      titulo: 'Criar Unidade',
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    };
  },

  components: {
    UnidadeForm: __WEBPACK_IMPORTED_MODULE_0__components_UnidadeForm___default.a
  },
  methods: {
    loadModel: function loadModel() {
      this.unidade = {
        nome: '',
        cnpj: '',
        intervaloStorage: '',
        cor: '',
        idSistema: '',
        assinatura: false,
        qrcode: false,
        ativa: false
      };
    },
    onSubmit: function onSubmit() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/unidades', this.unidade).then(function (response) {
        self.$store.commit('changeUnidadeQuery', { query: self.unidade.nome });
        self.$router.push({ name: 'Unidade' });
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao criar unidade ' + e;
        self.snackbar = true;
      });
    },
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.loadModel();
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'usuario',
  data: function data() {
    return {
      pagination: {
        sortBy: 'nome',
        descending: 'asc',
        page: 1,
        rowsPerPage: 10
      },
      acao: 0,
      items: [],
      errors: [],
      total: null,
      titulo: 'Usuários',
      dialog: false,
      confirm: {
        title: 'Atenção',
        contentHtml: 'Tem certeza que deseja apagar a(s) usuario(s) selecionada(s).',
        ok: 'Sim',
        cancel: 'Não'
      },
      loading: true,
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: '',
      search: '',
      selected: [],
      selectAll: '',
      headers: [{ text: 'NOME',
        sortable: true,
        value: 'nome',
        align: 'left'
      }, {
        text: 'LOGIN',
        align: 'left',
        sortable: true,
        value: 'username'
      }, { text: 'PERMISSÃO',
        sortable: true,
        value: 'permissoes',
        align: 'left'
      }]
    };
  },

  components: {},
  computed: {},
  watch: {
    search: function search() {
      this.$store.commit('changeUsuarioQuery', { query: this.search });
    },

    pagination: {
      handler: function handler() {
        this.atualizarLista();
      },

      deep: true
    }
  },
  methods: {
    excluir: function excluir() {
      var _this = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected).forEach(function (index) {
        var usuario = _this.selected[index];
        console.log('vai excluir ' + usuario.id);

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/usuarios/' + usuario.id).then(function (response) {
          self.atualizarLista();

          self.tipoAlerta = 'success';
          self.textAlerta = 'Usuário excluído com sucesso';
          self.snackbar = true;
        }).catch(function (e) {
          self.tipoAlerta = 'error';
          self.textAlerta = 'Erro ao excluir Usuário';
          self.snackbar = true;

          console.log(e);
        });

        setTimeout(function () {
          self.selected = [];
        }, 3000);

        _this.dialog = false;
      });
    },
    editar: function editar() {
      var index = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected)[0];
      var usuario = this.selected[index];
      this.$router.push({ name: 'UsuarioEdit', params: { id: usuario.id } });
    },
    pesquisar: function pesquisar() {
      this.pagination.page = 1;
      this.atualizarLista();
    },
    atualizarLista: function atualizarLista() {
      var _this2 = this;

      this.loading = true;
      var _pagination = this.pagination,
          sortBy = _pagination.sortBy,
          descending = _pagination.descending,
          page = _pagination.page,
          rowsPerPage = _pagination.rowsPerPage;

      var offset = (page - 1) * rowsPerPage;
      var porPagina = rowsPerPage;
      if (rowsPerPage !== -1 && rowsPerPage !== 5 && rowsPerPage !== 10 && rowsPerPage !== 25) {
        porPagina = 10;
      }
      var order = 'asc';
      if (!descending) {
        order = 'asc';
      }
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/usuarios?sort=' + sortBy + '&order=' + order + '&offset=' + offset + '&max=' + porPagina + '&q=' + this.search).then(function (response) {
        _this2.items = response.data.list;
        _this2.total = response.data.total;
        _this2.pagination.totalItems = response.data.total;
        if (response.data.porPagina) {
          _this2.pagination.rowsPerPage = response.data.porPagina;
        }
        _this2.loading = false;
      }).catch(function (e) {
        _this2.errors.push(e);
      });
    }
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    this.search = this.$store.state.usuarioQuery;
    this.atualizarLista();
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UsuarioForm__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UsuarioForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_UsuarioForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'usuario-edit',
  data: function data() {
    return {
      usuario: {},
      itemsPermissoes: [],
      titulo: 'Editar Usuário',
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    };
  },

  components: {
    UsuarioForm: __WEBPACK_IMPORTED_MODULE_0__components_UsuarioForm___default.a
  },
  methods: {
    loadModel: function loadModel() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/usuarios/' + this.$route.params.id).then(function (response) {
        self.usuario = response.data;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao carregar usuário';
        self.snackbar = true;
      });
    },
    onSubmit: function onSubmit() {
      var self = this;
      if (!this.usuario.password) {
        delete this.usuario.password;
      }
      console.log(this.usuario);
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/usuarios/' + this.usuario.id, this.usuario).then(function (response) {
        console.log(response);
        self.tipoAlerta = 'success';
        self.textAlerta = 'Usuário alterado com sucesso';
        self.snackbar = true;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        if (e.response) {
          self.textAlerta = e.response.data.message;
        } else {
          self.textAlerta = 'Erro ao criar usuário';
        }
        self.snackbar = true;
      });
    },
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.loadModel();
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'usuario-form',
  props: {
    usuario: {}
  },
  data: function data() {
    return {
      mostrarSenha: true,
      itemsPermissoes: [],
      empresas: [],
      unidades: [],
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    };
  },

  components: {},
  methods: {
    pupularPermissoes: function pupularPermissoes() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/permissoes').then(function (response) {
        self.itemsPermissoes = response.data.list;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao carregar permissões';
        self.snackbar = true;
      });
    },
    pupularEmpresas: function pupularEmpresas() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/empresas').then(function (response) {
        self.empresas = response.data.list;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao carregar empresas';
        self.snackbar = true;
      });
    },
    pupularUnidades: function pupularUnidades() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/unidades').then(function (response) {
        self.unidades = response.data.list;
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        self.textAlerta = 'Erro ao carregar unidades';
        self.snackbar = true;
      });
    }
  },
  created: function created() {
    this.pupularPermissoes();
    this.pupularEmpresas();
    this.pupularUnidades();
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UsuarioForm__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UsuarioForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_UsuarioForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'usuario-new',
  data: function data() {
    return {
      usuario: {},
      titulo: 'Criar Usuário',
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    };
  },

  components: {
    UsuarioForm: __WEBPACK_IMPORTED_MODULE_0__components_UsuarioForm___default.a
  },
  methods: {
    loadModel: function loadModel() {
      this.usuario = {
        nome: '',
        cpf: '',
        ativo: false
      };
    },
    onSubmit: function onSubmit() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/usuarios', this.usuario).then(function (response) {
        self.$store.commit('changeUsuarioQuery', { query: self.usuario.nome });
        self.$router.push({ name: 'Usuario' });
      }).catch(function (e) {
        self.tipoAlerta = 'error';
        if (e.response) {
          self.textAlerta = e.response.data.message;
        } else {
          self.textAlerta = 'Erro ao criar usuário';
        }
        self.snackbar = true;
      });
    },
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.loadModel();
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'viewer-dialog',
  props: {
    resultado: {},
    display: false,
    link: ''
  },
  data: function data() {
    return {
      dialogViewer: false,
      loaded: false,
      linkViewer: '',
      nomePaciente: '',
      linkDownload: ''
    };
  },

  components: {},
  watch: {
    display: function display(value) {
      this.dialogViewer = value;
    },
    resultado: function resultado() {
      this.popularDados();
    },
    link: function link() {
      if (this.link) {
        console.log('iframe cargado... ' + this.link);
        var iframe = document.getElementById('viframe_' + this.resultado.id);
        iframe.src = this.link;
        iframe.onload = function () {
          console.log('loaded... ');
        };
      }
    }
  },
  methods: {
    close: function close() {
      this.dialogViewer = false;
      this.$emit('update:display', false);
    },
    popularDados: function popularDados() {
      if (this.resultado) {
        this.nomePaciente = this.resultado.nomePaciente;
        this.linkDownload = 'https://storage.googleapis.com/' + this.resultado.intervaloStorage + '/' + this.resultado.idConnect + '/' + this.resultado.idConnect + '.zip';
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.popularDados();
    this.loaded = true;
  }
});

/***/ }),
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */,
/* 324 */,
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 51,
	"./af.js": 51,
	"./ar": 58,
	"./ar-dz": 52,
	"./ar-dz.js": 52,
	"./ar-kw": 53,
	"./ar-kw.js": 53,
	"./ar-ly": 54,
	"./ar-ly.js": 54,
	"./ar-ma": 55,
	"./ar-ma.js": 55,
	"./ar-sa": 56,
	"./ar-sa.js": 56,
	"./ar-tn": 57,
	"./ar-tn.js": 57,
	"./ar.js": 58,
	"./az": 59,
	"./az.js": 59,
	"./be": 60,
	"./be.js": 60,
	"./bg": 61,
	"./bg.js": 61,
	"./bm": 62,
	"./bm.js": 62,
	"./bn": 64,
	"./bn-bd": 63,
	"./bn-bd.js": 63,
	"./bn.js": 64,
	"./bo": 65,
	"./bo.js": 65,
	"./br": 66,
	"./br.js": 66,
	"./bs": 67,
	"./bs.js": 67,
	"./ca": 68,
	"./ca.js": 68,
	"./cs": 69,
	"./cs.js": 69,
	"./cv": 70,
	"./cv.js": 70,
	"./cy": 71,
	"./cy.js": 71,
	"./da": 72,
	"./da.js": 72,
	"./de": 75,
	"./de-at": 73,
	"./de-at.js": 73,
	"./de-ch": 74,
	"./de-ch.js": 74,
	"./de.js": 75,
	"./dv": 76,
	"./dv.js": 76,
	"./el": 77,
	"./el.js": 77,
	"./en-au": 78,
	"./en-au.js": 78,
	"./en-ca": 79,
	"./en-ca.js": 79,
	"./en-gb": 80,
	"./en-gb.js": 80,
	"./en-ie": 81,
	"./en-ie.js": 81,
	"./en-il": 82,
	"./en-il.js": 82,
	"./en-in": 83,
	"./en-in.js": 83,
	"./en-nz": 84,
	"./en-nz.js": 84,
	"./en-sg": 85,
	"./en-sg.js": 85,
	"./eo": 86,
	"./eo.js": 86,
	"./es": 90,
	"./es-do": 87,
	"./es-do.js": 87,
	"./es-mx": 88,
	"./es-mx.js": 88,
	"./es-us": 89,
	"./es-us.js": 89,
	"./es.js": 90,
	"./et": 91,
	"./et.js": 91,
	"./eu": 92,
	"./eu.js": 92,
	"./fa": 93,
	"./fa.js": 93,
	"./fi": 94,
	"./fi.js": 94,
	"./fil": 95,
	"./fil.js": 95,
	"./fo": 96,
	"./fo.js": 96,
	"./fr": 99,
	"./fr-ca": 97,
	"./fr-ca.js": 97,
	"./fr-ch": 98,
	"./fr-ch.js": 98,
	"./fr.js": 99,
	"./fy": 100,
	"./fy.js": 100,
	"./ga": 101,
	"./ga.js": 101,
	"./gd": 102,
	"./gd.js": 102,
	"./gl": 103,
	"./gl.js": 103,
	"./gom-deva": 104,
	"./gom-deva.js": 104,
	"./gom-latn": 105,
	"./gom-latn.js": 105,
	"./gu": 106,
	"./gu.js": 106,
	"./he": 107,
	"./he.js": 107,
	"./hi": 108,
	"./hi.js": 108,
	"./hr": 109,
	"./hr.js": 109,
	"./hu": 110,
	"./hu.js": 110,
	"./hy-am": 111,
	"./hy-am.js": 111,
	"./id": 112,
	"./id.js": 112,
	"./is": 113,
	"./is.js": 113,
	"./it": 115,
	"./it-ch": 114,
	"./it-ch.js": 114,
	"./it.js": 115,
	"./ja": 116,
	"./ja.js": 116,
	"./jv": 117,
	"./jv.js": 117,
	"./ka": 118,
	"./ka.js": 118,
	"./kk": 119,
	"./kk.js": 119,
	"./km": 120,
	"./km.js": 120,
	"./kn": 121,
	"./kn.js": 121,
	"./ko": 122,
	"./ko.js": 122,
	"./ku": 123,
	"./ku.js": 123,
	"./ky": 124,
	"./ky.js": 124,
	"./lb": 125,
	"./lb.js": 125,
	"./lo": 126,
	"./lo.js": 126,
	"./lt": 127,
	"./lt.js": 127,
	"./lv": 128,
	"./lv.js": 128,
	"./me": 129,
	"./me.js": 129,
	"./mi": 130,
	"./mi.js": 130,
	"./mk": 131,
	"./mk.js": 131,
	"./ml": 132,
	"./ml.js": 132,
	"./mn": 133,
	"./mn.js": 133,
	"./mr": 134,
	"./mr.js": 134,
	"./ms": 136,
	"./ms-my": 135,
	"./ms-my.js": 135,
	"./ms.js": 136,
	"./mt": 137,
	"./mt.js": 137,
	"./my": 138,
	"./my.js": 138,
	"./nb": 139,
	"./nb.js": 139,
	"./ne": 140,
	"./ne.js": 140,
	"./nl": 142,
	"./nl-be": 141,
	"./nl-be.js": 141,
	"./nl.js": 142,
	"./nn": 143,
	"./nn.js": 143,
	"./oc-lnc": 144,
	"./oc-lnc.js": 144,
	"./pa-in": 145,
	"./pa-in.js": 145,
	"./pl": 146,
	"./pl.js": 146,
	"./pt": 148,
	"./pt-br": 147,
	"./pt-br.js": 147,
	"./pt.js": 148,
	"./ro": 149,
	"./ro.js": 149,
	"./ru": 150,
	"./ru.js": 150,
	"./sd": 151,
	"./sd.js": 151,
	"./se": 152,
	"./se.js": 152,
	"./si": 153,
	"./si.js": 153,
	"./sk": 154,
	"./sk.js": 154,
	"./sl": 155,
	"./sl.js": 155,
	"./sq": 156,
	"./sq.js": 156,
	"./sr": 158,
	"./sr-cyrl": 157,
	"./sr-cyrl.js": 157,
	"./sr.js": 158,
	"./ss": 159,
	"./ss.js": 159,
	"./sv": 160,
	"./sv.js": 160,
	"./sw": 161,
	"./sw.js": 161,
	"./ta": 162,
	"./ta.js": 162,
	"./te": 163,
	"./te.js": 163,
	"./tet": 164,
	"./tet.js": 164,
	"./tg": 165,
	"./tg.js": 165,
	"./th": 166,
	"./th.js": 166,
	"./tk": 167,
	"./tk.js": 167,
	"./tl-ph": 168,
	"./tl-ph.js": 168,
	"./tlh": 169,
	"./tlh.js": 169,
	"./tr": 170,
	"./tr.js": 170,
	"./tzl": 171,
	"./tzl.js": 171,
	"./tzm": 173,
	"./tzm-latn": 172,
	"./tzm-latn.js": 172,
	"./tzm.js": 173,
	"./ug-cn": 174,
	"./ug-cn.js": 174,
	"./uk": 175,
	"./uk.js": 175,
	"./ur": 176,
	"./ur.js": 176,
	"./uz": 178,
	"./uz-latn": 177,
	"./uz-latn.js": 177,
	"./uz.js": 178,
	"./vi": 179,
	"./vi.js": 179,
	"./x-pseudo": 180,
	"./x-pseudo.js": 180,
	"./yo": 181,
	"./yo.js": 181,
	"./zh-cn": 182,
	"./zh-cn.js": 182,
	"./zh-hk": 183,
	"./zh-hk.js": 183,
	"./zh-mo": 184,
	"./zh-mo.js": 184,
	"./zh-tw": 185,
	"./zh-tw.js": 185
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 325;

/***/ }),
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(291)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(355),
  /* scopeId */
  "data-v-0546826e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(294)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(358),
  /* scopeId */
  "data-v-09074fe5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(297)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(361),
  /* scopeId */
  "data-v-1cdd9e8f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(301)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(365),
  /* scopeId */
  "data-v-29b467ab",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(300)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(364),
  /* scopeId */
  "data-v-290546a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(305)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(369),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(313)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(377),
  /* scopeId */
  "data-v-5ada719d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(299)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(363),
  /* scopeId */
  "data-v-28592447",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(302)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(366),
  /* scopeId */
  "data-v-32554af3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(316)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(380),
  /* scopeId */
  "data-v-75e35db3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(317)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(381),
  /* scopeId */
  "data-v-7e42155d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(308)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(372),
  /* scopeId */
  "data-v-459edf1d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(315)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(379),
  /* scopeId */
  "data-v-6ded0ac3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(290)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(354),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(292)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(356),
  /* scopeId */
  "data-v-07650f09",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(298)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(362),
  /* scopeId */
  "data-v-1d6e2edc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(311)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(375),
  /* scopeId */
  "data-v-5846006c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(318)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(382),
  /* scopeId */
  "data-v-90b3a898",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(321)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(385),
  /* scopeId */
  "data-v-bb19a0ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(312)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(376),
  /* scopeId */
  "data-v-585723b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(295)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(359),
  /* scopeId */
  "data-v-0bd9ac34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(320)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(384),
  /* scopeId */
  "data-v-a059afec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(309)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(373),
  /* scopeId */
  "data-v-4c06dc34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(314)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(378),
  /* scopeId */
  "data-v-6d4a6166",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.resultado) ? _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogViewer),
      callback: function($$v) {
        _vm.dialogViewer = $$v
      },
      expression: "dialogViewer"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(this.resultado.nomePaciente))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": _vm.linkDownload
    }
  }, [_c('v-icon', [_vm._v("file_download")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow": "hidden"
    }
  }, [(_vm.loaded) ? _c('iframe', {
    attrs: {
      "id": ("viframe_" + (_vm.resultado.id)),
      "frameborder": "0",
      "width": "100%",
      "height": "100%"
    }
  }) : _vm._e()])], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fundo fill-height",
    style: (_vm.fundo)
  }, [_c('v-container', {
    attrs: {
      "fixed": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "flex": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "elevation-12",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', [(_vm.logoApp) ? _c('v-card-media', {
    attrs: {
      "src": _vm.logoApp,
      "height": "120px",
      "contain": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.sucesso || _vm.mensagem) ? _c('v-card-text', [(_vm.sucesso) ? _c('h3', {
    staticClass: "title primary--text font-weight-light my-3"
  }, [_vm._v("Solicitação feita com sucesso!")]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "primary--text font-weight-light my-3"
  }, [_vm._v(_vm._s(_vm.mensagem))])]) : (!_vm.emailCode && !_vm.usuario) ? _c('v-card-text', [_c('v-form', {
    ref: "formEmail",
    attrs: {
      "validate": ""
    },
    model: {
      value: (_vm.validEmail),
      callback: function($$v) {
        _vm.validEmail = $$v
      },
      expression: "validEmail"
    }
  }, [_c('h3', {
    staticClass: "title primary--text font-weight-light my-3"
  }, [_vm._v("Solicitar Alteração de Senha")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "placeholder": "nome@email.com.br",
      "rules": _vm.emailRules,
      "hint": "Informe o e-mail da conta que deseja redefinir a senha",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/login",
      "color": "secondary"
    }
  }, [_vm._v("cancelar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "disabled": !_vm.validEmail,
      "color": "primary"
    },
    on: {
      "click": _vm.solicitarAlteracao
    }
  }, [_vm._v("Enviar E-mail")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.emailCode && !_vm.emailCode.dataAlteracao) ? _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "mb-3 title secondary--text font-weight-light"
  }, [_vm._v("Defina sua nova senha de acesso.")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "senha",
      "label": "Senha",
      "id": "senha",
      "required": "",
      "rules": _vm.senhaRules,
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); },
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    model: {
      value: (_vm.senha),
      callback: function($$v) {
        _vm.senha = $$v
      },
      expression: "senha"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "confirmacaoPassword",
      "label": "Confirmação de Senha",
      "id": "confirmacaoPassword",
      "required": "",
      "rules": _vm.csenhaRules,
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    on: {
      "click:append": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); }
    },
    model: {
      value: (_vm.csenha),
      callback: function($$v) {
        _vm.csenha = $$v
      },
      expression: "csenha"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.valid,
      "color": "primary"
    },
    on: {
      "click": _vm.trocarSenha
    }
  }, [_vm._v(" Confirmar ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.usuario && !_vm.emailCode) ? _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.validUsuario),
      callback: function($$v) {
        _vm.validUsuario = $$v
      },
      expression: "validUsuario"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "mb-3 title secondary--text font-weight-light"
  }, [_vm._v("Defina sua nova senha de acesso.")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.usuarioLogado && !_vm.usuarioLogado.email) ? _c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "placeholder": "nome@email.com.br",
      "rules": _vm.emailRules,
      "hint": "Informe o e-mail da conta que deseja redefinir a senha",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Senha Atual",
      "id": "password",
      "required": "",
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); },
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "senha",
      "label": "Nova Senha",
      "id": "senha",
      "required": "",
      "rules": _vm.senhaRules,
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); },
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    model: {
      value: (_vm.senha),
      callback: function($$v) {
        _vm.senha = $$v
      },
      expression: "senha"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "confirmacaoPassword",
      "label": "Confirmação de Nova Senha",
      "id": "confirmacaoPassword",
      "required": "",
      "rules": _vm.csenhaRules,
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    on: {
      "click:append": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); }
    },
    model: {
      value: (_vm.csenha),
      callback: function($$v) {
        _vm.csenha = $$v
      },
      expression: "csenha"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.validUsuario,
      "color": "primary"
    },
    on: {
      "click": _vm.trocarSenhaLogado
    }
  }, [_vm._v(" Confirmar ")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.textAlerta) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "flex": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "pt-5": ""
    }
  }, [_c('v-card', [(_vm.logoApp) ? _c('v-card-media', {
    attrs: {
      "src": _vm.logoApp,
      "height": "120px",
      "contain": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('h1', {
    staticClass: "display-1 text-xs-center"
  }, [_vm._v("Dados de Acesso")]), _vm._v(" "), _c('v-card', {
    staticClass: "pa-2 my-2 grey lighten-5",
    attrs: {
      "flat": ""
    }
  }, [_c('h1', {
    staticClass: "headline primary--text"
  }, [_vm._v("Paciente: "), _c('b', [_vm._v(_vm._s(_vm.resultado.nomePaciente))])]), _vm._v(" "), _c('h3', {
    staticClass: "subheading primary--text"
  }, [_vm._v("Exame: "), _c('b', [_vm._v(_vm._s(_vm.resultado.tipoExame) + " - " + _vm._s(_vm.resultado.modalidade))])])]), _vm._v(" "), _c('v-form', {
    ref: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['###.###.###-##']),
      expression: "['###.###.###-##']"
    }],
    attrs: {
      "label": "CPF",
      "required": "",
      "rules": [_vm.validarMinimo(_vm.resultado.cpfPaciente, 14), _vm.obrigatorioRules[0]]
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.buscarUsuario($event)
      },
      "change": function($event) {
        _vm.buscouCPF = false
      }
    },
    model: {
      value: (_vm.resultado.cpfPaciente),
      callback: function($$v) {
        _vm.$set(_vm.resultado, "cpfPaciente", $$v)
      },
      expression: "resultado.cpfPaciente"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.buscouCPF) ? _c('v-text-field', {
    attrs: {
      "label": "Email",
      "type": "username",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.usuario.email),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "email", $$v)
      },
      expression: "usuario.email"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.buscouCPF) ? _c('v-text-field', {
    attrs: {
      "label": "Login",
      "disabled": true,
      "type": "username",
      "persistent-hint": true,
      "hint": "Login será os números do CPF",
      "required": ""
    },
    model: {
      value: (_vm.usuario.username),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "username", $$v)
      },
      expression: "usuario.username"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.buscouCPF) ? _c('v-text-field', {
    attrs: {
      "label": "Senha",
      "required": "",
      "rules": _vm.obrigatorioRules,
      "append-icon": _vm.esconderSenha ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.esconderSenha = !_vm.esconderSenha); },
      "type": _vm.esconderSenha ? 'password' : 'text'
    },
    model: {
      value: (_vm.usuario.password),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "password", $$v)
      },
      expression: "usuario.password"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.buscouCPF) ? _c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['(##) #####-####']),
      expression: "['(##) #####-####']"
    }],
    attrs: {
      "label": "Celular (whatsapp)",
      "type": "username",
      "placeholder": "(##) #####-####",
      "rules": [_vm.validarMinimo(_vm.resultado.telefonePaciente, 15)],
      "hint": "Informe o número do whatsapp"
    },
    model: {
      value: (_vm.resultado.telefonePaciente),
      callback: function($$v) {
        _vm.$set(_vm.resultado, "telefonePaciente", $$v)
      },
      expression: "resultado.telefonePaciente"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.buscouCPF) ? _c('v-checkbox', {
    attrs: {
      "label": "Autoriza o envio por Whatsapp",
      "disabled": !_vm.whatsapp,
      "color": "green"
    },
    model: {
      value: (_vm.resultado.whatsapp),
      callback: function($$v) {
        _vm.$set(_vm.resultado, "whatsapp", $$v)
      },
      expression: "resultado.whatsapp"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.buscouCPF) ? _c('v-checkbox', {
    attrs: {
      "label": "Autoriza o envio por E-mail",
      "disabled": !_vm.usuario.email,
      "color": "green"
    },
    model: {
      value: (_vm.resultado.enviaEmail),
      callback: function($$v) {
        _vm.$set(_vm.resultado, "enviaEmail", $$v)
      },
      expression: "resultado.enviaEmail"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": ""
    },
    on: {
      "click": _vm.limpar
    }
  }, [_vm._v("limpar")]), _vm._v(" "), (!_vm.buscouCPF) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.buscarUsuario()
      }
    }
  }, [_vm._v("continuar")]) : _vm._e(), _vm._v(" "), (_vm.buscouCPF) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.atualizar()
      }
    }
  }, [_vm._v(_vm._s(_vm.tituloBotaoSubmit))]) : _vm._e(), _vm._v(" "), (_vm.buscouCPF && _vm.resultado.usuario && _vm.resultado.usuario.id) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.print
    }
  }, [_vm._v("visualizar impressão")]) : _vm._e(), _vm._v(" "), (_vm.buscouCPF && _vm.resultado.usuario && _vm.resultado.usuario.id) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.sendMail
    }
  }, [_vm._v("enviar por email")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.textAlerta) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline hidden-xs-only"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-1 mr-1 ",
    attrs: {
      "light": "",
      "ripple": "",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.pesquisar()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-xs-only"
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mr-1",
    attrs: {
      "append-icon": "search",
      "label": "Pesquisar",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.pesquisar()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), (_vm.selected.length == 1) ? _c('v-btn', {
    staticClass: "ml-1 mr-1 ",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "title": "Resultado PDF",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openPdf()
      }
    }
  }, [_c('v-icon', [_vm._v("picture_as_pdf")])], 1) : _vm._e(), _vm._v(" "), (_vm.selected.length == 1 && _vm.resultado.possuiImagem) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "title": "Visualizador Web",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openViewer()
      }
    }
  }, [_c('v-icon', [_vm._v("collections")])], 1) : _vm._e(), _vm._v(" "), (_vm.selected.length == 1) ? _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "title": "Resultado Paciente",
      "target": "r",
      "href": _vm.linkResultado,
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("description")])], 1) : _vm._e(), _vm._v(" "), (_vm.selected.length == 1) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "title": "Cartão Paciente",
      "target": "c",
      "href": _vm.linkCartaoAcesso,
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("assignment_ind")])], 1) : _vm._e(), _vm._v(" "), (_vm.selected.length == 1 && _vm.resultado.possuiImagem) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "title": "Impressão Imagem",
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogImpressao = true
      }
    }
  }, [_c('v-icon', [_vm._v("print")])], 1) : _vm._e(), _vm._v(" "), (_vm.selected.length > 0) ? _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "slot": "activator",
      "title": "Excluir",
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "selected-key": "id",
      "select-all": "",
      "disable-initial-sort": true,
      "pagination": _vm.pagination,
      "total-items": _vm.total,
      "loading": _vm.loading
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return _c('tr', {
          class: {
            'red lighten-4': props.item.idNovaVersao
          }
        }, [_c('td', [_c('v-checkbox', {
          attrs: {
            "color": "primary",
            "hide-details": ""
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.moment(props.item.dataCadastro).calendar()) + "\n          "), (props.item.idNovaVersao) ? _c('b', {
          staticClass: "red--text"
        }, [_vm._v("\n            Possui Nova Versão\n          ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.idExame))]), _vm._v(" "), _c('td', {
          staticClass: "text"
        }, [_vm._v(_vm._s(props.item.nomePaciente))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cpfPaciente))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.empresa.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.dataAssinatura ? _vm.moment(props.item.dataAssinatura).format('DD/MM/YYYY hh:mm') : 'Sem Assinatura'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cpfAssinatura))])])
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "450"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.confirm.title))]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.confirm.contentHtml))]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.confirm.cancel))]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.excluir()
      }
    }
  }, [_vm._v(_vm._s(_vm.confirm.ok))])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1), _vm._v(" "), _c('PdfDialog', {
    attrs: {
      "resultado": _vm.resultado,
      "link": _vm.linkPdf,
      "display": _vm.dialogPdf
    },
    on: {
      "update:display": function($event) {
        _vm.dialogPdf = $event
      }
    }
  }), _vm._v(" "), _c('ViewerDialog', {
    attrs: {
      "resultado": _vm.resultado,
      "link": _vm.linkViewer,
      "display": _vm.dialogViewer
    },
    on: {
      "update:display": function($event) {
        _vm.dialogViewer = $event
      }
    }
  }), _vm._v(" "), (_vm.selected.length == 1 && _vm.resultado.possuiImagem) ? _c('impressao-dialog', {
    attrs: {
      "resultado": _vm.resultado,
      "mostrar": _vm.dialogImpressao
    },
    on: {
      "update:mostrar": function($event) {
        _vm.dialogImpressao = $event
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nome",
      "required": "",
      "label": "Nome"
    },
    model: {
      value: (_vm.usuario.nome),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "nome", $$v)
      },
      expression: "usuario.nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "required": "",
      "label": "E-mail"
    },
    model: {
      value: (_vm.usuario.email),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "email", $$v)
      },
      expression: "usuario.email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "username",
      "required": "",
      "label": "Login"
    },
    model: {
      value: (_vm.usuario.username),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "username", $$v)
      },
      expression: "usuario.username"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Senha",
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); },
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    model: {
      value: (_vm.usuario.password),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "password", $$v)
      },
      expression: "usuario.password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "chips": "",
      "label": "Permissões",
      "items": _vm.itemsPermissoes,
      "item-text": "authority",
      "item-value": "id",
      "multiple": "",
      "max-height": "400",
      "hint": "Selecione as permissões",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.usuario.authorities),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "authorities", $$v)
      },
      expression: "usuario.authorities"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "cpf",
      "label": "CPF"
    },
    model: {
      value: (_vm.usuario.cpf),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "cpf", $$v)
      },
      expression: "usuario.cpf"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "crm",
      "label": "CRM"
    },
    model: {
      value: (_vm.usuario.crm),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "crm", $$v)
      },
      expression: "usuario.crm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "crmUf",
      "label": "UF CRM"
    },
    model: {
      value: (_vm.usuario.crmUf),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "crmUf", $$v)
      },
      expression: "usuario.crmUf"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Ativo",
      "color": "primary"
    },
    model: {
      value: (_vm.usuario.enabled),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "enabled", $$v)
      },
      expression: "usuario.enabled"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Bloqueado",
      "color": "primary"
    },
    model: {
      value: (_vm.usuario.accountLocked),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "accountLocked", $$v)
      },
      expression: "usuario.accountLocked"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Conta Expirada",
      "color": "primary"
    },
    model: {
      value: (_vm.usuario.accountExpired),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "accountExpired", $$v)
      },
      expression: "usuario.accountExpired"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Senha Expirada",
      "color": "primary"
    },
    model: {
      value: (_vm.usuario.passwordExpired),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "passwordExpired", $$v)
      },
      expression: "usuario.passwordExpired"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "chips": "",
      "label": "Empresas",
      "items": _vm.empresas,
      "item-text": "nome",
      "item-value": "id",
      "multiple": "",
      "max-height": "400",
      "hint": "Selecione as empresas",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.usuario.empresas),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "empresas", $$v)
      },
      expression: "usuario.empresas"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "chips": "",
      "label": "Unidades",
      "items": _vm.unidades,
      "item-text": "nome",
      "item-value": "id",
      "multiple": "",
      "max-height": "400",
      "hint": "Selecione as unidades",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.usuario.unidades),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "unidades", $$v)
      },
      expression: "usuario.unidades"
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline hidden-xs-only"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-1 mr-1 ",
    attrs: {
      "light": "",
      "ripple": "",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.pesquisar()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-xs-only"
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mr-1",
    attrs: {
      "append-icon": "search",
      "label": "Pesquisar",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.pesquisar()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), (this.selected.length == 1) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editar()
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (this.selected.length > 0) ? _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "slot": "activator",
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "selected-key": "id",
      "select-all": "",
      "disable-initial-sort": true,
      "pagination": _vm.pagination,
      "total-items": _vm.total,
      "loading": _vm.loading
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-checkbox', {
          attrs: {
            "color": "primary",
            "hide-details": ""
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1), _vm._v(" "), (props.item.ativa === false) ? _c('td', {
          staticClass: "name"
        }, [_vm._v("\n         " + _vm._s(props.item.nome) + "\n        "), _c('b', {
          staticClass: "cert inativo"
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "title": "Inativo"
          }
        }, [_vm._v("block")])], 1)]) : _c('td', {
          staticClass: "name"
        }, [_vm._v("\n            " + _vm._s(props.item.nome) + "\n       ")]), _vm._v(" "), _c('td', {
          staticClass: "name"
        }, [_vm._v(_vm._s(props.item.nomeFantasia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cnpj))]), _vm._v(" "), _c('td', [(props.item.assinatura === true) ? _c('v-icon', {
          attrs: {
            "color": "grey",
            "title": "Assinatura Eletrônica"
          }
        }, [_vm._v("assignment")]) : _vm._e(), _vm._v(" "), (props.item.impressao === true) ? _c('v-icon', {
          attrs: {
            "color": "grey",
            "title": "Impressão"
          }
        }, [_vm._v("print")]) : _vm._e(), _vm._v(" "), (props.item.qrcode === true) ? _c('v-icon', {
          attrs: {
            "color": "grey",
            "title": "QRCode"
          }
        }, [_vm._v("qr_code")]) : _vm._e(), _vm._v(" "), (props.item.whatsapp === true) ? _c('v-icon', {
          attrs: {
            "color": "grey",
            "title": "WhatsApp"
          }
        }, [_vm._v("tap_and_play")]) : _vm._e(), _vm._v(" "), (props.item.removerDocumentoAssinatura === true) ? _c('v-icon', {
          attrs: {
            "color": "grey",
            "title": "CPF Removido"
          }
        }, [_vm._v("subtitles_off")]) : _vm._e()], 1)]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "450"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.confirm.title))]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.confirm.contentHtml))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.confirm.cancel))]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.excluir()
      }
    }
  }, [_vm._v(_vm._s(_vm.confirm.ok))])], 1)], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "to": "/admin/empresa/new",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary",
      "dark": "",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/unidade",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("list")])], 1)], 1), _vm._v(" "), _c('form', {
    attrs: {
      "validate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-card-text', [_c('UnidadeForm', {
    attrs: {
      "unidade": _vm.unidade
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {}, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "ripple": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "dark": "",
      "ripple": ""
    }
  }, [_vm._v("Gravar")])], 1)])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "label": "Empresa",
      "items": _vm.empresas,
      "item-text": "nome",
      "item-value": "id",
      "max-height": "400",
      "hint": "Selecione a empresa",
      "persistent-hint": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.unidade.empresa),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "empresa", $$v)
      },
      expression: "unidade.empresa"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nome",
      "required": "",
      "label": "Nome"
    },
    model: {
      value: (_vm.unidade.nome),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "nome", $$v)
      },
      expression: "unidade.nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "cnpj",
      "required": "",
      "label": "CNPJ"
    },
    model: {
      value: (_vm.unidade.cnpj),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "cnpj", $$v)
      },
      expression: "unidade.cnpj"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nomeFantasia",
      "required": "",
      "label": "Nome Fantasia"
    },
    model: {
      value: (_vm.unidade.nomeFantasia),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "nomeFantasia", $$v)
      },
      expression: "unidade.nomeFantasia"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "idSistema",
      "label": "ID Sistema"
    },
    model: {
      value: (_vm.unidade.idSistema),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "idSistema", $$v)
      },
      expression: "unidade.idSistema"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "intervaloStorage",
      "required": "",
      "label": "Storage"
    },
    model: {
      value: (_vm.unidade.intervaloStorage),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "intervaloStorage", $$v)
      },
      expression: "unidade.intervaloStorage"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "color",
      "name": "cor",
      "label": "Cor"
    },
    model: {
      value: (_vm.unidade.cor),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "cor", $$v)
      },
      expression: "unidade.cor"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "site",
      "label": "Site"
    },
    model: {
      value: (_vm.unidade.site),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "site", $$v)
      },
      expression: "unidade.site"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Email"
    },
    model: {
      value: (_vm.unidade.email),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "email", $$v)
      },
      expression: "unidade.email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "textoRodape",
      "label": "Texto Rodapé"
    },
    model: {
      value: (_vm.unidade.textoRodape),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "textoRodape", $$v)
      },
      expression: "unidade.textoRodape"
    }
  })], 1)], 1), _vm._v(" "), (_vm.unidade.id) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    ref: "fileTextField",
    attrs: {
      "prepend-icon": "attach_file",
      "single-line": "",
      "label": "Logo"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onFocus($event)
      }
    },
    model: {
      value: (_vm.unidade.logoUrl),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "logoUrl", $$v)
      },
      expression: "unidade.logoUrl"
    }
  }), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "accept": "*",
      "multiple": false
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    ref: "fileTextField",
    attrs: {
      "prepend-icon": "attach_file",
      "single-line": "",
      "label": "Carimbo"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onFocus2($event)
      }
    },
    model: {
      value: (_vm.unidade.carimboUrl),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "carimboUrl", $$v)
      },
      expression: "unidade.carimboUrl"
    }
  }), _vm._v(" "), _c('input', {
    ref: "fileInput2",
    attrs: {
      "type": "file",
      "accept": "*",
      "multiple": false
    },
    on: {
      "change": _vm.onFileChange2
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Ativo",
      "color": "primary"
    },
    model: {
      value: (_vm.unidade.ativa),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "ativa", $$v)
      },
      expression: "unidade.ativa"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Assinar Exames",
      "color": "primary"
    },
    model: {
      value: (_vm.unidade.assinatura),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "assinatura", $$v)
      },
      expression: "unidade.assinatura"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Remover Documento Assinatura",
      "color": "primary"
    },
    model: {
      value: (_vm.unidade.removerDocumentoAssinatura),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "removerDocumentoAssinatura", $$v)
      },
      expression: "unidade.removerDocumentoAssinatura"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Adicionar QRCode",
      "color": "primary"
    },
    model: {
      value: (_vm.unidade.qrcode),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "qrcode", $$v)
      },
      expression: "unidade.qrcode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Whatsapp",
      "color": "primary"
    },
    model: {
      value: (_vm.unidade.whatsapp),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "whatsapp", $$v)
      },
      expression: "unidade.whatsapp"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Pesquisa Satisfação",
      "color": "primary"
    },
    model: {
      value: (_vm.unidade.pesquisa),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "pesquisa", $$v)
      },
      expression: "unidade.pesquisa"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "label": "Modelo QR Code",
      "items": _vm.modeloQRcodes,
      "item-text": "descricao",
      "item-value": "id",
      "max-height": "400",
      "hint": "Selecione o modelo de QRCode",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.unidade.modeloQRcode),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "modeloQRcode", $$v)
      },
      expression: "unidade.modeloQRcode"
    }
  })], 1)], 1), _vm._v(" "), (_vm.unidade.id) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "tamanhoQr",
      "label": "Tamanho QRCode"
    },
    model: {
      value: (_vm.unidade.tamanhoQr),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "tamanhoQr", $$v)
      },
      expression: "unidade.tamanhoQr"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "xAss",
      "label": "Pos X QRCode"
    },
    model: {
      value: (_vm.unidade.xQr),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "xQr", $$v)
      },
      expression: "unidade.xQr"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "yQr",
      "label": "Pos Y QRCode"
    },
    model: {
      value: (_vm.unidade.yQr),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "yQr", $$v)
      },
      expression: "unidade.yQr"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.unidade.id) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "tamanhoFont",
      "label": "Tamanho Fonte Assinatura"
    },
    model: {
      value: (_vm.unidade.tamanhoFont),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "tamanhoFont", $$v)
      },
      expression: "unidade.tamanhoFont"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "xAss",
      "label": "Pos X Assinatura"
    },
    model: {
      value: (_vm.unidade.xAss),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "xAss", $$v)
      },
      expression: "unidade.xAss"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "yAss",
      "label": "Pos Y Assinatura"
    },
    model: {
      value: (_vm.unidade.yAss),
      callback: function($$v) {
        _vm.$set(_vm.unidade, "yAss", $$v)
      },
      expression: "unidade.yAss"
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary",
      "dark": "",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/empresa/new",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/empresa",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("list")])], 1)], 1), _vm._v(" "), _c('form', {
    attrs: {
      "validate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-card-text', [_c('EmpresaForm', {
    attrs: {
      "empresa": _vm.empresa
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {}, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "ripple": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "dark": "",
      "ripple": ""
    }
  }, [_vm._v("Gravar")])], 1)])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [(_vm.resultado) ? _c('resultado-card', {
    attrs: {
      "resultado": _vm.resultado
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary",
      "dark": "",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/medico/new",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/medico",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("list")])], 1)], 1), _vm._v(" "), _c('form', {
    attrs: {
      "validate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-card-text', [_c('MedicoForm', {
    attrs: {
      "medico": _vm.medico
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {}, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "ripple": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "dark": "",
      "ripple": ""
    }
  }, [_vm._v("Gravar")])], 1)])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary",
      "dark": "",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/empresa",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("list")])], 1)], 1), _vm._v(" "), _c('form', {
    attrs: {
      "validate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-card-text', [_c('EmpresaForm', {
    attrs: {
      "empresa": _vm.empresa
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {}, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "ripple": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "dark": "",
      "ripple": ""
    }
  }, [_vm._v("Gravar")])], 1)])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary",
      "dark": "",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/medico",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("list")])], 1)], 1), _vm._v(" "), _c('form', {
    attrs: {
      "validate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-card-text', [_c('MedicoForm', {
    attrs: {
      "medico": _vm.medico
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {}, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "ripple": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "dark": "",
      "ripple": ""
    }
  }, [_vm._v("Gravar")])], 1)])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "light": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nome",
      "required": "",
      "label": "Nome"
    },
    model: {
      value: (_vm.medico.nome),
      callback: function($$v) {
        _vm.$set(_vm.medico, "nome", $$v)
      },
      expression: "medico.nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "cpf",
      "type": "number",
      "required": "",
      "label": "CPF"
    },
    model: {
      value: (_vm.medico.cpf),
      callback: function($$v) {
        _vm.$set(_vm.medico, "cpf", $$v)
      },
      expression: "medico.cpf"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "crm",
      "required": "",
      "label": "CRM"
    },
    model: {
      value: (_vm.medico.crm),
      callback: function($$v) {
        _vm.$set(_vm.medico, "crm", $$v)
      },
      expression: "medico.crm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "crmUf",
      "required": "",
      "label": "CRM UF (sigla)"
    },
    model: {
      value: (_vm.medico.crmUf),
      callback: function($$v) {
        _vm.$set(_vm.medico, "crmUf", $$v)
      },
      expression: "medico.crmUf"
    }
  })], 1)], 1), _vm._v(" "), (_vm.medico.id) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    ref: "fileTextField",
    attrs: {
      "prepend-icon": "attach_file",
      "single-line": "",
      "label": "certificado"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onFocus($event)
      }
    },
    model: {
      value: (_vm.medico.certificado),
      callback: function($$v) {
        _vm.$set(_vm.medico, "certificado", $$v)
      },
      expression: "medico.certificado"
    }
  }), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "accept": "*",
      "multiple": false
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "senhaCertificado",
      "label": "Senha Certificado",
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); },
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    model: {
      value: (_vm.medico.senhaCertificado),
      callback: function($$v) {
        _vm.$set(_vm.medico, "senhaCertificado", $$v)
      },
      expression: "medico.senhaCertificado"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Vencimento Certificado",
      "prepend-icon": "event",
      "readonly": ""
    },
    model: {
      value: (_vm.dataVencimentoCertificado),
      callback: function($$v) {
        _vm.dataVencimentoCertificado = $$v
      },
      expression: "dataVencimentoCertificado"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Ativo",
      "color": "primary"
    },
    model: {
      value: (_vm.medico.ativo),
      callback: function($$v) {
        _vm.$set(_vm.medico, "ativo", $$v)
      },
      expression: "medico.ativo"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "title",
      "required": "",
      "label": "Título"
    },
    model: {
      value: (_vm.menu.title),
      callback: function($$v) {
        _vm.$set(_vm.menu, "title", $$v)
      },
      expression: "menu.title"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "to",
      "label": "Link"
    },
    model: {
      value: (_vm.menu.to),
      callback: function($$v) {
        _vm.$set(_vm.menu, "to", $$v)
      },
      expression: "menu.to"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "icon",
      "label": "Ícone"
    },
    model: {
      value: (_vm.menu.icon),
      callback: function($$v) {
        _vm.$set(_vm.menu, "icon", $$v)
      },
      expression: "menu.icon"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "ordem",
      "required": "",
      "label": "Ordem"
    },
    model: {
      value: (_vm.menu.ordem),
      callback: function($$v) {
        _vm.$set(_vm.menu, "ordem", $$v)
      },
      expression: "menu.ordem"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "chips": "",
      "autocomplete": "",
      "label": "Permissões",
      "items": _vm.itemsPermissoes,
      "item-text": "authority",
      "item-value": "id",
      "multiple": "",
      "max-height": "400",
      "hint": "Selecione as permissões",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.menu.permissoes),
      callback: function($$v) {
        _vm.$set(_vm.menu, "permissoes", $$v)
      },
      expression: "menu.permissoes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "chips": "",
      "autocomplete": "",
      "label": "Menu Pai",
      "items": _vm.itemsMenu,
      "item-text": "title",
      "item-value": "id",
      "max-height": "400",
      "hint": "Selecione o menu pai",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.menu.menuPai),
      callback: function($$v) {
        _vm.$set(_vm.menu, "menuPai", $$v)
      },
      expression: "menu.menuPai"
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fundo fill-height",
    style: (_vm.fundo)
  }, [_c('v-container', {
    attrs: {
      "fixed": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "flex": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "elevation-12",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title primary--text"
  }, [_vm._v("\n          PORTAL DE RESULTADOS\n        ")]), _vm._v(" "), (_vm.logoApp) ? _c('v-card-media', {
    attrs: {
      "src": _vm.logoApp,
      "height": "120px",
      "contain": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "username",
      "label": "Login",
      "id": "username",
      "type": "username",
      "required": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Senha",
      "id": "password",
      "required": "",
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); },
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "primary"
    }
  }, [_vm._v("Entrar")])], 1)], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.textAlerta) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.resultado) ? _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogPdf),
      callback: function($$v) {
        _vm.dialogPdf = $$v
      },
      expression: "dialogPdf"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(this.resultado.nomePaciente))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": _vm.linkDownload
    }
  }, [_c('v-icon', [_vm._v("file_download")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow": "hidden"
    },
    attrs: {
      "id": ("iframeContext_" + (_vm.resultado.id))
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "500"
    },
    model: {
      value: (_vm.mostrar),
      callback: function($$v) {
        _vm.mostrar = $$v
      },
      expression: "mostrar"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline primary lighten-1 white--text"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [(this.resultado.totalImagens) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "subheading"
  }, [_vm._v("Quanditade de imagens do exame: " + _vm._s(_vm.resultado.totalImagens))])])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.mostraPorPagina) ? _c('v-select', {
    attrs: {
      "required": "",
      "label": "Imagens por Página",
      "items": _vm.quantidadesPorPagina,
      "item-text": "descricao",
      "item-value": "id",
      "hint": "Selecione a quantidade de imagens por página",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.porPagina),
      callback: function($$v) {
        _vm.porPagina = $$v
      },
      expression: "porPagina"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "label": "Padrão de seleção das imagens",
      "items": _vm.selecaoImages,
      "item-text": "descricao",
      "item-value": "id",
      "hint": "Selecione o padrão de seleção de imagens",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.pular),
      callback: function($$v) {
        _vm.pular = $$v
      },
      expression: "pular"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.fechar($event)
      }
    }
  }, [_vm._v("Fechar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.porPagina || !_vm.pular
    },
    nativeOn: {
      "click": function($event) {
        _vm.imprimir($event)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("print")]), _vm._v(" Gerar Impressão")], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary",
      "dark": "",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/menu",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("list")])], 1)], 1), _vm._v(" "), _c('form', {
    attrs: {
      "validate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-card-text', [_c('MenuForm', {
    attrs: {
      "menu": _vm.menu
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {}, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "ripple": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "dark": "",
      "ripple": ""
    }
  }, [_vm._v("Gravar")])], 1)])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "light": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary",
      "dark": "",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/usuario/new",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/usuario",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("list")])], 1)], 1), _vm._v(" "), _c('form', {
    attrs: {
      "validate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-card-text', [_c('UsuarioForm', {
    attrs: {
      "usuario": _vm.usuario
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {}, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "ripple": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "dark": "",
      "ripple": ""
    }
  }, [_vm._v("Gravar")])], 1)])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nome",
      "required": "",
      "label": "Nome"
    },
    model: {
      value: (_vm.empresa.nome),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "nome", $$v)
      },
      expression: "empresa.nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "cnpj",
      "required": "",
      "label": "CNPJ"
    },
    model: {
      value: (_vm.empresa.cnpj),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "cnpj", $$v)
      },
      expression: "empresa.cnpj"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nomeFantasia",
      "required": "",
      "label": "Nome Fantasia"
    },
    model: {
      value: (_vm.empresa.nomeFantasia),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "nomeFantasia", $$v)
      },
      expression: "empresa.nomeFantasia"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "idSistema",
      "label": "ID Sistema"
    },
    model: {
      value: (_vm.empresa.idSistema),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "idSistema", $$v)
      },
      expression: "empresa.idSistema"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "intervaloStorage",
      "required": "",
      "label": "Storage"
    },
    model: {
      value: (_vm.empresa.intervaloStorage),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "intervaloStorage", $$v)
      },
      expression: "empresa.intervaloStorage"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "color",
      "name": "cor",
      "label": "Cor"
    },
    model: {
      value: (_vm.empresa.cor),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "cor", $$v)
      },
      expression: "empresa.cor"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "site",
      "label": "Site"
    },
    model: {
      value: (_vm.empresa.site),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "site", $$v)
      },
      expression: "empresa.site"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Email"
    },
    model: {
      value: (_vm.empresa.email),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "email", $$v)
      },
      expression: "empresa.email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "textoRodape",
      "label": "Texto Rodapé"
    },
    model: {
      value: (_vm.empresa.textoRodape),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "textoRodape", $$v)
      },
      expression: "empresa.textoRodape"
    }
  })], 1)], 1), _vm._v(" "), (_vm.empresa.id) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    ref: "fileTextField",
    attrs: {
      "prepend-icon": "attach_file",
      "single-line": "",
      "label": "Logo"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onFocus($event)
      }
    },
    model: {
      value: (_vm.empresa.logoUrl),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "logoUrl", $$v)
      },
      expression: "empresa.logoUrl"
    }
  }), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "accept": "*",
      "multiple": false
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    ref: "fileTextField",
    attrs: {
      "prepend-icon": "attach_file2",
      "single-line": "",
      "label": "Carimbo"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onFocus2($event)
      }
    },
    model: {
      value: (_vm.empresa.carimboUrl),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "carimboUrl", $$v)
      },
      expression: "empresa.carimboUrl"
    }
  }), _vm._v(" "), _c('input', {
    ref: "fileInput2",
    attrs: {
      "type": "file",
      "accept": "*",
      "multiple": false
    },
    on: {
      "change": _vm.onFileChange2
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Ativo",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.ativa),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "ativa", $$v)
      },
      expression: "empresa.ativa"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Assinar Exames",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.assinatura),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "assinatura", $$v)
      },
      expression: "empresa.assinatura"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Remover Documento Assinatura",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.removerDocumentoAssinatura),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "removerDocumentoAssinatura", $$v)
      },
      expression: "empresa.removerDocumentoAssinatura"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Impressão de Imagens",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.impressao),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "impressao", $$v)
      },
      expression: "empresa.impressao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Whatsapp",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.whatsapp),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "whatsapp", $$v)
      },
      expression: "empresa.whatsapp"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Pesquisa Satisfação",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.pesquisa),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "pesquisa", $$v)
      },
      expression: "empresa.pesquisa"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Envio automático",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.envioAutomaticoResultado),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "envioAutomaticoResultado", $$v)
      },
      expression: "empresa.envioAutomaticoResultado"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Adicionar QRCode",
      "color": "primary"
    },
    model: {
      value: (_vm.empresa.qrcode),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "qrcode", $$v)
      },
      expression: "empresa.qrcode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "label": "Modelo QR Code",
      "items": _vm.modeloQRcodes,
      "item-text": "descricao",
      "item-value": "id",
      "max-height": "400",
      "hint": "Selecione o modelo de QRCode",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.empresa.modeloQRcode),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "modeloQRcode", $$v)
      },
      expression: "empresa.modeloQRcode"
    }
  })], 1)], 1), _vm._v(" "), (_vm.empresa.id) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "tamanhoQr",
      "label": "Tamanho QRCode"
    },
    model: {
      value: (_vm.empresa.tamanhoQr),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "tamanhoQr", $$v)
      },
      expression: "empresa.tamanhoQr"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "xAss",
      "label": "Pos X QRCode"
    },
    model: {
      value: (_vm.empresa.xQr),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "xQr", $$v)
      },
      expression: "empresa.xQr"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "yQr",
      "label": "Pos Y QRCode"
    },
    model: {
      value: (_vm.empresa.yQr),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "yQr", $$v)
      },
      expression: "empresa.yQr"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.empresa.id) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "tamanhoFont",
      "label": "Tamanho Fonte Assinatura"
    },
    model: {
      value: (_vm.empresa.tamanhoFont),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "tamanhoFont", $$v)
      },
      expression: "empresa.tamanhoFont"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "xAss",
      "label": "Pos X Assinatura"
    },
    model: {
      value: (_vm.empresa.xAss),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "xAss", $$v)
      },
      expression: "empresa.xAss"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "yAss",
      "label": "Pos Y Assinatura"
    },
    model: {
      value: (_vm.empresa.yAss),
      callback: function($$v) {
        _vm.$set(_vm.empresa, "yAss", $$v)
      },
      expression: "empresa.yAss"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogTemplate = true
      }
    }
  }, [_vm._v("Template Cartão de Acesso")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogTemplate),
      callback: function($$v) {
        _vm.dialogTemplate = $$v
      },
      expression: "dialogTemplate"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogTemplate = false
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Template Cartão de Acesso")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow": "hidden"
    },
    attrs: {
      "id": "iframeContext"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empresa.templateCartao),
      expression: "empresa.templateCartao"
    }],
    staticClass: "template",
    domProps: {
      "value": (_vm.empresa.templateCartao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empresa, "templateCartao", $event.target.value)
      }
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.resultados), function(resultado) {
    return _c('v-flex', {
      key: resultado.id,
      attrs: {
        "lg4": ""
      }
    }, [_c('resultado-card', {
      attrs: {
        "resultado": resultado
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary",
      "dark": "",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/unidade/new",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/unidade",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("list")])], 1)], 1), _vm._v(" "), _c('form', {
    attrs: {
      "validate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-card-text', [_c('UnidadeForm', {
    attrs: {
      "unidade": _vm.unidade
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {}, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "ripple": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "dark": "",
      "ripple": ""
    }
  }, [_vm._v("Gravar")])], 1)])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline hidden-xs-only"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-1 mr-1 ",
    attrs: {
      "light": "",
      "ripple": "",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.pesquisar()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-xs-only"
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mr-1",
    attrs: {
      "append-icon": "search",
      "label": "Pesquisar",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.pesquisar()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), (this.selected.length == 1) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editar()
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (this.selected.length > 0) ? _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "slot": "activator",
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "selected-key": "id",
      "select-all": "",
      "disable-initial-sort": true,
      "pagination": _vm.pagination,
      "total-items": _vm.total,
      "loading": _vm.loading
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-checkbox', {
          attrs: {
            "color": "primary",
            "hide-details": ""
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1), _vm._v(" "), (props.item.ativo === false) ? _c('td', [_vm._v("\n          " + _vm._s(props.item.nome) + "\n         "), _c('b', {
          staticClass: "cert inativo"
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "title": "Inativo"
          }
        }, [_vm._v("block")])], 1)]) : _c('td', [_vm._v("\n              " + _vm._s(props.item.nome) + "\n         ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cpf))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.crmUf + ' ' + props.item.crm))]), _vm._v(" "), _c('td', [(props.item.dataVencimentoCertificado === null) ? _c('div', {
          staticClass: "cert vencimento"
        }, [_vm._v("\nSem Certificado           ")]) : (props.item.dataVencimentoCertificado != null && _vm.moment(props.item.dataVencimentoCertificado, 'DD/MM/YYYY').isBefore(_vm.today, 'DD/MM/YYYY')) ? _c('div', {
          staticClass: "error vencimento"
        }, [_vm._v("\n     Certificado Expirado\n   ")]) : _c('div', {
          staticClass: "accent vencimento"
        }, [_vm._v(" " + _vm._s(_vm.moment(props.item.dataVencimentoCertificado, "YYYY-MM-DD").format('LL')) + " ")])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "450"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.confirm.title))]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.confirm.contentHtml))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.confirm.cancel))]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.excluir()
      }
    }
  }, [_vm._v(_vm._s(_vm.confirm.ok))])], 1)], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "to": "/admin/medico/new",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.textAlerta) + "\n        "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary",
      "dark": "",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/usuario",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("list")])], 1)], 1), _vm._v(" "), _c('form', {
    attrs: {
      "validate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-card-text', [_c('UsuarioForm', {
    attrs: {
      "usuario": _vm.usuario
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {}, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "ripple": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "dark": "",
      "ripple": ""
    }
  }, [_vm._v("Gravar")])], 1)])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "light": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-alert', {
    attrs: {
      "color": "error",
      "icon": "warning",
      "value": "true"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.mensagem) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline hidden-xs-only"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-xs-only"
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mr-1",
    attrs: {
      "append-icon": "search",
      "label": "Pesquisar",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.limparSelecao()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), (this.selected.length == 1) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editar()
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (this.selected.length > 0) ? _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "slot": "activator",
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "selected-key": "id",
      "select-all": "",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-checkbox', {
          attrs: {
            "color": "primary",
            "hide-details": ""
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.title))]), _vm._v(" "), _c('td', _vm._l((props.item.permissoes), function(value) {
          return _c('div', {
            key: value.id,
            staticClass: "accent permissao"
          }, [_vm._v("\n            " + _vm._s(value.authority) + "\n          ")])
        }))]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.confirm.title))]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.confirm.contentHtml))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.confirm.cancel))]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.excluir()
      }
    }
  }, [_vm._v(_vm._s(_vm.confirm.ok))])], 1)], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "to": "/admin/menu/new",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary",
      "dark": "",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/menu/new",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/menu",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("list")])], 1)], 1), _vm._v(" "), _c('form', {
    attrs: {
      "validate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-card-text', [_c('MenuForm', {
    attrs: {
      "menu": _vm.menu
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {}, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "ripple": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "dark": "",
      "ripple": ""
    }
  }, [_vm._v("Gravar")])], 1)])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-container', {
    staticClass: "grey lighten-4",
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.resultado.id) ? _c('v-flex', {
    attrs: {
      "lg12": "",
      "xs12": "",
      "sm12": "",
      "md12": "",
      "xl12": ""
    }
  }, [_c('h1', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.resultado.nomePaciente))]), _vm._v(" "), (_vm.resultado.cpfPaciente) ? _c('h2', {
    staticClass: "subheading"
  }, [_vm._v("\n              CPF: " + _vm._s(_vm.resultado.cpfPaciente) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.resultado.dataNascimento) ? _c('h2', {
    staticClass: "subheading"
  }, [_vm._v("\n              Data Nascimento: " + _vm._s(_vm.resultado.dataNascimento) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.resultado.id) ? _c('v-flex', {
    attrs: {
      "lg4": "",
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-card', [_c('v-card-media', {
    ref: "resultado.id",
    attrs: {
      "src": _vm.buscarImage(_vm.resultado),
      "height": "200px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(_vm.resultado.tipoExame) + " - " + _vm._s(_vm.resultado.modalidade))]), _vm._v(" "), _c('div', [(_vm.resultado.medico) ? _c('span', [_vm._v("Médico: "), _c('strong', [_vm._v(_vm._s(_vm.resultado.medico.nome) + " ")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.resultado.dataAssinatura) ? _c('span', [_vm._v("Data Assinatura: "), _c('strong', [_vm._v(_vm._s(_vm.moment(_vm.resultado.dataAssinatura).format('DD/MM/YYYY hh:mm')) + " ")])]) : _vm._e()])])]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "white"
  }, [_c('v-spacer'), _vm._v(" "), (_vm.resultado.medico) ? _c('v-btn', {
    staticClass: "ml-1 mr-1 ",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "outline": "",
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.openPdf(_vm.resultado)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("picture_as_pdf")]), _vm._v(" Visualizar Laudo\n                  ")], 1) : _vm._e(), _vm._v(" "), (_vm.resultado.possuiImagem) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "outline": "",
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.openViewer(_vm.resultado)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("collections")]), _vm._v(" Visualizar Imagens\n                  ")], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('PdfDialog', {
    attrs: {
      "resultado": _vm.resultado,
      "link": _vm.linkPdf,
      "display": _vm.dialogPdf
    },
    on: {
      "update:display": function($event) {
        _vm.dialogPdf = $event
      }
    }
  }), _vm._v(" "), _c('ViewerDialog', {
    attrs: {
      "resultado": _vm.resultado,
      "link": _vm.linkViewer,
      "display": _vm.dialogViewer
    },
    on: {
      "update:display": function($event) {
        _vm.dialogViewer = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.resultado.id) ? _c('v-card', [_c('v-toolbar', {
    style: (("background-color: " + (_vm.resultado.empresa.cor)))
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(" " + _vm._s(_vm.nomeFantasia))])], 1), _vm._v(" "), _c('v-card-text', [(_vm.resultado.id) ? _c('v-flex', {
    attrs: {
      "lg12": "",
      "xs12": "",
      "sm12": "",
      "md12": "",
      "xl12": ""
    }
  }, [_c('h1', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.resultado.nomePaciente))]), _vm._v(" "), (_vm.resultado.cpfPaciente) ? _c('h2', {
    staticClass: "subheading"
  }, [_vm._v("\n        CPF: " + _vm._s(_vm.resultado.cpfPaciente) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.resultado.dataNascimento) ? _c('h2', {
    staticClass: "subheading"
  }, [_vm._v("\n        Data Nascimento: " + _vm._s(_vm.resultado.dataNascimento) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.resultado.dataAssinatura == null) ? _c('h2', [_vm._v("Data Publicação: "), _c('strong', [_vm._v(_vm._s(_vm.moment(_vm.resultado.dataCadastro).format('DD/MM/YYYY hh:mm')) + " ")]), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.resultado.dataAssinatura) ? _c('h2', [_vm._v("Data Assinatura: "), _c('strong', [_vm._v(_vm._s(_vm.moment(_vm.resultado.dataAssinatura).format('DD/MM/YYYY hh:mm')) + " ")]), _c('br')]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.resultado.possuiImagem) ? _c('v-card-media', {
    ref: "resultado.id",
    attrs: {
      "src": _vm.buscarImage(_vm.resultado),
      "height": "200px"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(_vm.resultado.tipoExame) + " - " + _vm._s(_vm.resultado.modalidade))]), _vm._v(" "), _c('div', [(_vm.resultado.medico) ? _c('span', [_vm._v("Médico Executor: "), _c('strong', [_vm._v(_vm._s(_vm.resultado.medico.nome) + " ")]), _vm._v(" "), _c('strong', [_vm._v(" - CRM" + _vm._s(_vm.resultado.medico.crmUf) + "  " + _vm._s(_vm.resultado.medico.crm) + "  ")])]) : _vm._e()])])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "white"
  }, [(_vm.resultado.medico) ? _c('v-btn', {
    staticClass: "ml-1 mr-1 ",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "outline": "",
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.openPdf(_vm.resultado)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("picture_as_pdf")]), _vm._v(" Visualizar Laudo\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.resultado.possuiImagem) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "round": "",
      "outline": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.openViewer(_vm.resultado)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("collections")]), _vm._v(" Visualizar Imagens\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.resultado.possuiImagem) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "round": "",
      "outline": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("share")]), _vm._v(" Compartilhar\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.resultado.possuiImagem && _vm.resultado.empresa.impressao) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "round": "",
      "outline": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogImpressao = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("print")]), _vm._v(" Imagens para Impressão\n    ")], 1) : _vm._e()], 1), _vm._v(" "), _c('PdfDialog', {
    attrs: {
      "resultado": _vm.resultado,
      "link": _vm.linkPdf,
      "display": _vm.dialogPdf
    },
    on: {
      "update:display": function($event) {
        _vm.dialogPdf = $event
      }
    }
  }), _vm._v(" "), _c('ViewerDialog', {
    attrs: {
      "resultado": _vm.resultado,
      "link": _vm.linkViewer,
      "display": _vm.dialogViewer
    },
    on: {
      "update:display": function($event) {
        _vm.dialogViewer = $event
      }
    }
  }), _vm._v(" "), (_vm.resultado.id) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Compartilhar Resultado")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": "",
      "xs12": "",
      "sm12": "",
      "md12": "",
      "xl12": ""
    }
  }, [_c('h2', {
    staticClass: "subheading"
  }, [_vm._v("Empresa: "), _c('b', [_vm._v(_vm._s(_vm.resultado.empresa.nome))])]), _vm._v(" "), (_vm.resultado.unidade) ? _c('h2', {
    staticClass: "subheading"
  }, [_vm._v("Unidade: "), _c('b', [_vm._v(_vm._s(_vm.resultado.unidade.nome))])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "subheading"
  }, [_vm._v("Paciente: "), _c('b', [_vm._v(_vm._s(_vm.resultado.nomePaciente))])]), _vm._v(" "), _c('h2', {
    staticClass: "subheading"
  }, [_vm._v("Tipo do Exame: "), _c('b', [_vm._v(_vm._s(_vm.resultado.tipoExame) + " - " + _vm._s(_vm.resultado.modalidade))])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": "",
      "xs12": "",
      "sm12": "",
      "md12": "",
      "xl12": ""
    }
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.compartilharEmail($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.emailRules,
      "name": "email",
      "label": "Digite o e-mail"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": "",
      "xs12": "",
      "sm12": "",
      "md12": "",
      "xl12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.valid
    },
    nativeOn: {
      "click": function($event) {
        _vm.compartilharEmail()
      }
    }
  }, [_vm._v("Enviar por Email")]), _vm._v(" "), (_vm.detectmob()) ? _c('v-btn', {
    attrs: {
      "data-action": "share/whatsapp/share",
      "color": "green",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.compartilharWhatsapp()
      }
    }
  }, [_vm._v("WhatsApp")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('small', [_vm._v("* Este compartilhamento será váido por 7 dias")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('iframe', {
    attrs: {
      "id": "vframe",
      "frameborder": "0",
      "width": "0",
      "height": "0"
    }
  })]), _vm._v(" "), (_vm.resultado.possuiImagem && _vm.resultado.empresa.impressao) ? _c('impressao-dialog', {
    attrs: {
      "resultado": _vm.resultado,
      "mostrar": _vm.dialogImpressao
    },
    on: {
      "update:mostrar": function($event) {
        _vm.dialogImpressao = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.textAlerta) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline hidden-xs-only"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-1 mr-1 ",
    attrs: {
      "light": "",
      "ripple": "",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.pesquisar()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-xs-only"
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mr-1",
    attrs: {
      "append-icon": "search",
      "label": "Pesquisar",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.pesquisar()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), (this.selected.length == 1) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editar()
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (this.selected.length > 0) ? _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "slot": "activator",
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "selected-key": "id",
      "select-all": "",
      "disable-initial-sort": true,
      "pagination": _vm.pagination,
      "total-items": _vm.total,
      "loading": _vm.loading
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-checkbox', {
          attrs: {
            "color": "primary",
            "hide-details": ""
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('td', _vm._l((props.item.authorities), function(value) {
          return _c('div', {
            key: value.id,
            staticClass: "accent permissao"
          }, [_vm._v("\n            " + _vm._s(value.authority) + "\n          ")])
        }))]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.confirm.title))]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.confirm.contentHtml))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.confirm.cancel))]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.excluir()
      }
    }
  }, [_vm._v(_vm._s(_vm.confirm.ok))])], 1)], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "to": "/admin/usuario/new",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline hidden-xs-only"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-xs-only"
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mr-1",
    attrs: {
      "append-icon": "search",
      "label": "Pesquisar",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.limparSelecao()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), (this.selected.length == 1) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editar()
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (this.selected.length > 0) ? _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "slot": "activator",
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "selected-key": "id",
      "select-all": "",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-checkbox', {
          attrs: {
            "color": "primary",
            "hide-details": ""
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.empresa.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cnpj))])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "450"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.confirm.title))]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.confirm.contentHtml))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.confirm.cancel))]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.excluir()
      }
    }
  }, [_vm._v(_vm._s(_vm.confirm.ok))])], 1)], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "to": "/admin/unidade/new",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "ligth": ""
    }
  }, [(_vm.showMenu) ? _c('v-navigation-drawer', {
    attrs: {
      "id": "navigation-1",
      "fixed": "",
      "mini-variant": _vm.miniVariant,
      "clipped": _vm.clipped,
      "app": "",
      "dark": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.miniVariant = !_vm.miniVariant
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.miniVariant ? 'chevron_right' : 'chevron_left')
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-tile-content')], 1), _vm._v(" "), _vm._l((_vm.menuApp), function(item, i) {
    return _c('v-list-tile', {
      key: i,
      attrs: {
        "active-class": "itemmenu--text",
        "to": item.to,
        "value": item.active,
        "exact": ""
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(" " + _vm._s(item.title))])], 1)], 1)
  }), _vm._v(" "), (_vm.logado == null) ? _c('v-list-tile', {
    attrs: {
      "active-class": "itemmenu--text",
      "to": "/",
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Entrar")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.logado != null) ? _c('v-list-tile', {
    attrs: {
      "active-class": "itemmenu--text",
      "to": "/redefinir-senha",
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("password")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Alterar Senha")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.logado != null) ? _c('v-list-tile', {
    attrs: {
      "active-class": "itemmenu--text",
      "exact": ""
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Sair")])], 1)], 1) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.showMenu) ? _c('v-toolbar', {
    attrs: {
      "dense": "",
      "dark": "",
      "fixed": "",
      "app": "",
      "clipped-left": _vm.clipped,
      "color": "primary"
    }
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', {
    attrs: {
      "dark": ""
    }
  }, [_c('a', {
    staticClass: "linkTitulo",
    attrs: {
      "target": "_empresaOut",
      "href": _vm.linkEmpresa
    }
  }, [_vm._v(_vm._s(_vm.tituloApp))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._l((_vm.menuApp), function(item, i) {
    return _c('v-toolbar-items', {
      key: i,
      staticClass: "hidden-sm-and-down"
    }, [(item.to && !item.menuPai) ? _c('v-btn', {
      attrs: {
        "flat": "",
        "router": "",
        "to": item.to
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (!item.to) ? _c('v-menu', {
      attrs: {
        "attach": "",
        "bottom": "",
        "left": "",
        "offset-y": "",
        "max-height": "500"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "flat": ""
      },
      slot: "activator"
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")]), _vm._v(" "), _c('v-list', _vm._l((item.filhos), function(filho, f) {
      return _c('v-list-tile', {
        key: f,
        attrs: {
          "flat": "",
          "router": "",
          "to": filho.to
        }
      }, [_c('v-list-tile-title', [_vm._v(_vm._s(filho.title))])], 1)
    }))], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "left": "",
      "bottom": "",
      "origin": "top right",
      "transition": "v-scale-transition"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list', [(_vm.logado != null) ? _c('v-list-tile', {
    attrs: {
      "to": "/redefinir-senha"
    }
  }, [_c('v-list-tile-title', [_vm._v("Alterar Senha")])], 1) : _vm._e(), _vm._v(" "), (_vm.logado == null) ? _c('v-list-tile', {
    attrs: {
      "to": "/"
    }
  }, [_c('v-list-tile-title', [_vm._v("Entrar")])], 1) : _vm._e(), _vm._v(" "), (_vm.logado != null) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("Sair")])], 1) : _vm._e()], 1)], 1)], 2) : _vm._e(), _vm._v(" "), _c('v-content', [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ })
]),[218]);


// WEBPACK FOOTER //
// static/js/app.f8ebad2daac6ad130805.js